// Isolated V2 Rates / rate recommendation.
import React from 'react';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Container from 'react-bootstrap/Container'
import Modal from 'react-bootstrap/Modal'
import HorizontalSlider from '../Common/HorizontalSlider'
import ScrollBar from '../Common/components/ScrollBar';
import { isMobileOnly } from 'react-device-detect';
import { Redirect } from 'react-router-dom'
import { ChosenLoan, LoanProduct, service, fees } from '../State'
import * as com from "../Common.js"
import 'react-credit-cards/es/styles-compiled.css';
import { connect } from 'react-redux'
import { MonhtlyChangeBP } from '../Common/Tooltip'
import DetailsV2 from './DetailsV2'
import Comparison from './Comparison'
import * as act from "../Store/actions"
import { Link } from 'react-router-dom'
import { Spinner } from 'react-bootstrap';
import { Select, Table, Button, Skeleton, Modal as Mod, Row as RowAnt, Col as ColAnt, InputNumber, Tooltip, Checkbox } from 'antd';
import { computePricingInputs, computePricingLiabilities } from "../Tools/DTICalculator/dtiLoan"
import {
    getLosApplicationV2,
    patchSelectionV2,
    patchPropertyFieldsV2,
    patchLoanFieldsV2,
    patchLosRecommendedRatesV2,
    patchLosSelectedLoanV2,
} from "../DocumentChecklist/applicationV2Client"
import { adaptV2ToProductPickerView, alignSelectedLoanPurpose, cardForClosingCostDetails, emptyProductPickerView } from "./productPickerV2View"
import * as st from "../State"
import "./ProductPicker.css"
import CompareProduct from "../Tools/MortgageCalculators/CompareProductModal";
import { LiabilitiesHint } from "./LiabilitiesBreakdown"
import { formatDollars, parseDollars, warningSuffix } from "../Tools/ProductFilterModal/moneyInput"

// Prefer selection.loansize over a possibly stale selection.downpayment so Rate
// filters stay aligned with 1003 Loan amount / header LTV.
const resolvePurchaseAmounts = (view) => {
    const price = com.safeParseInt(view?.property?.salesprice)
    const rawSize = view?.selection?.loansize
    const hasLoansize = rawSize !== "" && rawSize != null
    if (hasLoansize) {
        const loansize = com.safeParseInt(rawSize)
        const downpayment = Math.max(0, price - loansize)
        const stale = com.safeParseInt(view?.selection?.downpayment) !== downpayment
        return { loansize, downpayment, defdownpayment: downpayment, healDownpayment: stale }
    }
    const downpayment = com.safeParseInt(view?.selection?.downpayment)
    return {
        loansize: Math.max(0, price - downpayment),
        downpayment,
        defdownpayment: downpayment,
        healDownpayment: false,
    }
}

// import _fees from "./rate-test-json.json"
// import pr from "./rate-preDti-test.json"
// import product from "./rate-product.json"
const mapStateToProps = (state) => {
    return {
        application: state.application,
        property: state.application.property,
        selection: state.application.selection,
        borrower: state.borrower,
    }
}

const mapDispatchToProps = (dispatch) => ({
    changeBorrowerInfo: (event, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(event.target.value, who, verb))
    },
    changeBorrowerInfoCheck: (event, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(event.target.checked, who, verb))
    },
    changePhoneInfo: (input, who, verb) => {
        dispatch(act.ChangeBorrowerInfo(input, who, verb))
    },
    updateSelectField: (input, verb) => {
        dispatch(act.UpdateSelectField(input, verb))
    },
    updateSelectedLoanField: (input, verb) => {
        dispatch(act.UpdateSelectedLoanField(input, verb))
    },
    updateApplicationAttribute: (input, verb) => {
        dispatch(act.UpdateApplicationAttribute(input, verb))
    },
    changeMainProperty: (value, verb) => {
        dispatch(act.ChangeMainProperty(value, verb))
    },
    changeMainPropertyUnits: (input) => {
        dispatch(act.ChangeMainPropertyUnits(input))
    },
    updateExpenses: (event, who, verb) => {
        dispatch(act.UpdateExpenses(event.target.value, who, verb))
    },
    updatePrepaidDefault: (name, period, prepaidperiods, amount) => {
        dispatch(act.UpdatePrepaidDefault(name, period, prepaidperiods, amount))
    },
    updateFico: (score) => {
        return new Promise((resolve) => {
            dispatch(act.UpdateFico(score))
            resolve()
        })
    }
});

var hash = require('object-hash');


const typeoptions = [
    { label: 'ARM 5/6', value: "arm56" },
    { label: 'ARM 7/6', value: "arm76" },
    { label: 'ARM 10/6', value: "arm106" },
    { label: 'Fixed', value: "fixed" }]

export const pointsExplained = <div><b>Mortgage points</b> are percentage of the loan that you pay to the lender for a <b>lower monthly rate</b>.
    <div className='my-2'>Conversely, <b>negative points</b> are lender credits that can be used by you to <b>lower your closing costs</b>, or be put into an impound account to pay your insurance and taxes. </div>Lender credits are paid to you in exchange for a <b>higher interest rate</b></div>


export const getFees = function (loanid) {
    if(!this.props.borrowerid) {
        return;
    }
    let token = sessionStorage.getItem("ZeitroA")
    this.setState({ loading: true })
    fetch('/data/getFees', {
        method: 'POST',
        headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
            "Content-Type": "application/json",
            "X-Borrower": this.props.borrowerid,
        },
    }).then(
        response => {
            if (response.status !== 200) {

                this.setState({
                    loading: false
                })
                return;
            }
            response.json().then(_fees => {

                let f = new fees(_fees)
                f.cannotshopservices = _fees.cannotshopservices
                f.canshopservices = _fees.canshopservices
                f.closingcostsfinanced = _fees.closingcostsfinanced
                f.deposit = _fees.deposit
                f.downpayment = _fees.downpayment
                f.fundsforborrower = _fees.fundsforborrower
                f.initialescrowpaymentsatclosing = _fees.initialescrowpaymentsatclosing
                f.othercosts = _fees.othercosts
                f.prepaids = _fees.prepaids
                f.recordingandgovernmentfees = _fees.recordingandgovernmentfees
                f.transfertax = _fees.transfertax
                f.sellerscredits = _fees.sellerscredits
                f.adjustmentsothercredits = _fees.adjustmentsothercredits
                if (_fees && _fees.Error == null && _fees.Status !== "Error") {
                    this.persistSelectField(f, "estimatedclosingcosts")
                }
                setTimeout(() => this.getDTI(loanid), 3000)
            })
        }

    ).catch((err) => {

        this.setState({ loading: false })
    });
}
export const getDTI = function (loanid, fico) {
    if(!this.props.borrowerid) {
        return;
    }
    let token = sessionStorage.getItem("ZeitroA")
    this.setState({ loading: true })

    if (loanid === undefined) {
        loanid = this.props.loanid || this.props.borrower?.loan_id
    }

    if (typeof loanid === "undefined" || loanid === null || ( loanid && loanid.length < 10)) {
        this.setState({ loading: false });
        return;
      }

    fetch('/data/getPreDTI?newSource=true', {
        method: 'POST',
        headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
            "Content-Type": "application/json",
            "X-Borrower": this.props.borrowerid,
            "X-Loan": typeof loanid === "undefined" ? "" : loanid,
        },

    }).then(
        response => {
            if (response.status !== 200) {
                alert("An internal error occurred while fetching the rates data. Please contact support@zeitro.com for help.")
                this.setState({
                    loading: false
                })
                return;
            }
            response.json().then(pr => {
                this.setState({ loading: false })

                if (typeof pr["Error"] !== "undefined") {
                    // alert("Sorry, but we are unable to provide rates right now. Please contact support@zeitro.com for help.")
                    this.setState({ loading: false })
                    return;
                } else {
                    this.loaded = true
                    this.fees = pr.dtiData[0].fees
                    this.fico = fico || pr.fico
                    if (this.fico !== 0) {
                        this.setState({fico: this.fico})
                    }
                    if (fico) {
                        pr.fico = fico
                    }
                    this.zeitro_fee = pr.zeitro_fee
                    this.prepaid_interest_days = pr.prepaid_interest_days
                    //this.persistSelectField(this.zeitro_fee.default, "ourfee")
                    this.persistSelectField(this.prepaid_interest_days, "prepaiddays")
                    this.productReload(pr)
                }
            })
        }

    ).catch((err) => {

        this.setState({ loading: false })
        alert("Network error")
    });
}
export const getCitizenship = function () {
    let status = this.app().borrower.citizenship
    if (status === "citizen") {
        return ["US_CITIZENS", ""]
    }
    if (status === "permanent") {
        return ["PERMANENT_RESIDENT_ALIEN", ""]
    }
    return ["NON_PERMANENT_RESIDENT_ALIEN", this.app().borrower.visa.replace('-', '_')]

}
export const getOccupancy = function () {
    switch (this.app().property.occupancy) {
        case "principal":
            return "PRIMARY"
        case "secondhome":
            return "SECOND_HOME"
        case "investment":
            return "INVESTMENT"
        default:
            alert("wrong occupancy")
            return "PRIMARY"
    }
}
export const getPropertyType = function () {
    let remap = {
        condominiumdetached: "CONDOMINIUM_DETACHED",
        condominium: "CONDOMINIUM_ATTACHED",
        pudattached: "PUD_ATTACHED",
        puddetached: "PUD_DETACHED",
        singlefamilyattached: "SINGLE_FAMILY_ATTACHED",
        singlefamilydetached: "SINGLE_FAMILY_DETACHED",
        twotofourfamily: "TWO_TO_FOUR_FAMILY",
        manufacturedhome: "MANUFACTURED_HOME"
    }
    let out = remap[this.app().property.propertytype]
    if (this.app().property.isManufacturedHome === true) {
        out = "MANUFACTURED_HOME"
    }
    return out
}

export const productReload = function (predti) {
    if (null == this.loaded)
        return
    // this one needs work
    let firstTimeHomeBuyer = (this.app().firsttimebuyer)
    let [citizenship, visa] = this.getCitizenship()

    if (this.app().product.mortgageapplied === "nonqm") {
        let incomeamount = com.safeParseFloat(this.app().borrower.nonqm.nonqmincomeamount)
        if (this.app().borrower.nonqm.nonqmincomeperiod === "yearly") {
            incomeamount = Math.round(incomeamount / 12)
        }
        predti.dtiData[0].monthly_income = incomeamount
    } else {
        predti.dtiData[0].monthly_income = this.state.income
    }
    // Same overlay as legacy: DSCR / getproducts use the Rates filter amounts,
    // sourced from V2 application + local edits, not Redux loanstates.
    predti.dtiData[0].monthly_payment = this.state.liabilities

    const getDSCR = () => {
        let monthlyDebt = com.safeParseInt(predti.dtiData[0].monthly_payment)
        if (com.safeParseInt(monthlyDebt) !== 0) {
            return parseFloat(
            (
                com.safeParseInt(this.app().borrower.nonqm.nonqmincomeamount) /
                monthlyDebt
            ).toFixed(2)
            );
        }
        return 100;
    };
    let propertyvalue = this.state.propertyvalue
    let request = {
        state: this.state.propertystate || this.app().property.state,
        county: this.state.propertycounty || this.app().property.county,
        purpose: com.Purpose2Calculator(this.app().property.purpose),
        loanAmount: com.safeParseInt(this.state.loansize),
        appraisal: propertyvalue != null ? propertyvalue.toString() : (
            this.app().property.purpose === "purchase"
                ? this.app().property.salesprice
                : this.app().property.appraisal
        ).toString(),
        estimatedClosingCosts: this.fees,
        firstTimeHomeBuyer: this.state.firstTimeHomeBuyer || firstTimeHomeBuyer,
        units: (this.state.propertytype || this.app().property.propertytype) === "twotofourfamily"
        ? com.safeParseInt(this.app().property.units)
        : 1,
        occupancy: this.getOccupancy(), // propagated
        selfemployed: this.app().borrower.occupation.selfemployed,
        property: com.getPropertyType(this.state.propertytype) || com.getPropertyType(this.app().property.propertytype),
        citizenship: citizenship,
        visaType: visa,
        incomeDocumentationType: this.app().product.mortgageapplied === "nonqm" ? "" : "FullDoc",
        DSCR: getDSCR(),
        preDTI: predti,
        nonQMDocTypes: this.app().borrower.nonqm.nonqmincometype,
    }

    // Five or more units is a commercial loan, and no product in the engine
    // prices one (it takes 1 to 4 units). Asked anyway, the request goes out as
    // a one-unit loan with no property type and comes back with residential
    // rates, so say so instead of quoting them.
    if ((this.state.propertytype || this.app().property.propertytype) === "commercial") {
        this.setState({
            loading: false, products: [], topProducts: [],
            errorText: <h5 className='sectionquestion my-5 text-wrap text-center'>Pricing covers 1 to 4 unit properties. A building with 5 or more units is a commercial loan and can't be priced here.</h5>,
        })
        return
    }

    let token = sessionStorage.getItem("ZeitroA")
    this.setState({ loading: true })
    fetch('/data/getproducts', {
        method: 'POST',
        headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
            "Content-Type": "application/json",
            "X-Borrower": this.props.borrowerid,
        },
        body: JSON.stringify(request)
    }).then(
        response => {
            if (response.status !== 200) {

                this.setState({
                    loading: false, errorText: <h1 className='mt-5'>Server error</h1>,
                    products: [], topProducts: []
                })
                if (this.failedProduct != null)
                    this.failedProduct()
                return;
            }
            response.json().then(pr => {
                
                let products = pr.result
                let status = pr.status
                if ("Ok" !== status) {
                    /*
                    - "0" # InternalError
                    - "1" # LowFICOError
                    - "2" # HighDTIError
                    - "3" # HighLTVError
                    - "4" # LowIncomeError
                    - "5" # MatrixNotFoundError
                    - "6" # UnqualifiedPropertyError
                    */

                    let msg = ""
                    let showDetails = () => {
                        if (pr == null) return ""
                        if ("undefined" !== typeof this.props.borrowerid) {
                            let out = []
                            let reasons = pr["ineligible_reasons"]
                            if (reasons == null) return ""
                            for (const [key, value] of Object.entries(reasons)) {
                                let entry = <div className="mt-2" style={{ fontSize: '1.2em', fontWeight: 'bold' }}>{com.capitalize(key)}</div>
                                out.push(<div> {entry} </div>)
                                if (value.LenderLevelReason !== "")
                                    out.push(<div>{value.LenderLevelReason}</div>)
                                else {
                                    let preasons = value.ProductLevelReasons
                                    /* eslint-disable-next-line no-unused-vars */
                                    if (preasons !== null) {
                                        for (const [key, value] of Object.entries(preasons)) {
                                            out.push(<div>{value.ProductName}: {value.IneligibleReason} </div>)
                                        }
                                    }
                                }

                            }
                            return out
                        } else
                            return ""

                    }
                    msg = <h5 className='sectionquestion my-5 text-wrap text-center'><span style={{ color: '#993333' }}>Matching engine could not find a suitable loan. Reason: </span> <br />{pr["message"]}<br /> <div className="text-left" style={{ fontSize: '0.7em' }}>{showDetails()}</div> </h5>
                    this.setState({
                        loading: false, errorText: msg, errorCode: pr["status code"],
                        products: [], topProducts: []
                    })
                    if (this.failedProduct != null)
                        this.failedProduct()
                    return
                }
                if (this.askedForAssistance()) {
                    products = this.filterForAssistance(products)
                }
                this.setState({ closingCostsDetail: pr.appliedClosingCostsDetail })
                this.processProducts(products)
                this.setState({ loading: false })
            })
        }

    ).catch((err) => {
        this.setState({ loading: false })
        this.setState({
            loading: false, errorText: <h1 className='mt-5'>{"Network Error"} </h1>,
            products: [], topProducts: []
        })
        if (this.failedProduct != null)
            this.failedProduct()
    });
}
export const getLTV = function () {
    let ltv = com.safeParseInt(this.state.loansize) * 100 / com.safeParseInt(this.app().property.appraisal)
    let cltv = (com.safeParseInt(this.state.loansize) + com.safeParseInt(this.cltv)) * 100 / com.safeParseInt(this.app().property.appraisal)
    let hcltv = (com.safeParseInt(this.state.loansize) + com.safeParseInt(this.hcltv)) * 100 / com.safeParseInt(this.app().property.appraisal)
    return [ltv, cltv, hcltv]
}

// 创建通用的过滤器组件
export const FilterItem = React.memo(({ title, width, children }) => (
    <div style={{ width: width, display: 'flex', flexDirection: 'column' }} className="filter-item">
        <div className='filterTitle'>{title}</div>
        <div style={{ marginTop: '8px', width: '100%' }}>{children}</div>
    </div>
));
export class ProductPickerV2 extends React.Component {
    constructor(props) {
        super(props);
        this._v2View = emptyProductPickerView()
        this._v2Loaded = false
        this.state = {
            typeselected: [],
            termselected: [],
            yearstohold: 7,

            loansize: 0,
            products: [],
            topProducts: [],
            loading: false,
            loadingApplication: true,
            v2View: emptyProductPickerView(),
            closingCostsDetail: null,
            weightclosing: this.app().selection.weightclosing,
            weighttotalcost: this.app().selection.weighttotalcost,
            weightmonthly: this.app().selection.weightmonthly ?? this.app().selection.ƒTriangggweightmonthly,
            showSelf: false,
            ltv: 60.0,
            cltv: 0,
            fico: this.app().scre,
            propertyvalue: 0,
            propertystate: "",
            propertycounty: "",
            currentbalance: 0,
            firstTimeHomeBuyer: this.app().firsttimebuyer,
            income: 0,
            liabilities: 0,
            // true after "Reset to 1003 values": the calculator's saved estimate is left out
            liabilitiesFrom1003: false,
            occupancy: "PRIMARY",
            propertytype: "",
            errorText: "",
            searchParams: {},
            downpayment: 30000,
            defdownpayment: 30000,
            viewkey: 0,
            paydown: 0,
            cashout: 30000,
            targetprice: 1,
            redirect: "",
            positionbyemail: {},
            statusloaded: false,
            showHelp: true,
            show: false,
            detailedCard: null,
            detailType: '',
            lenders: [],
            selectedlenders: ['all'],
            mtypes: [],
            selectedmtypes: ['all'],
            incomedoctypes: [],
            selectedincomedoctypes: [],
            selectedmaxreserves: -1,
            maxreserves: -1,
            showPriceChanged: false,
            selectedImage: null,
            needsAdjustment: false,
            comparisonSelections: {},
            showComparison: false,
            mincashout: 0,
            dtiSpreadsheetLoading: false,
            ratesToBeRecommended: [],
            showRecommendRatesModal: false,
            compareModal: false,
            showLeftButton: false,
            showRightButton: true,
            isModalOpen: false,
            isExporting: false,
            sortOrder: null,
            sortColumn: null,
            showFilterForm: false,
            isEditFilter: false,
            loanLimits: []
        }
        this.filtersWrapRef = React.createRef()
        this.hcltv = null
        this.cltv = null
        this.timer = 0
        this.lenders = []
        this.mtypes = []
        this.incomedoctypes = []
        this.changeshown = false
        this.oldmaxupfrontcost = null
        this.howmany2display = 5
        if (this.props.borrowerid)
            this.howmany2display *= 3
        const dtiInputs = this.dtiInputs()
        this.state.income = dtiInputs.income
        this.state.liabilities = dtiInputs.liabilities
        let propertyvalue = this.app().property.purpose === "purchase" ? this.app().property.salesprice : this.app().property.appraisal
        this.state.propertytype = this.app().property.propertytype === "mobilehome" ? "manufacturedhome" : this.app().property.propertytype
        this.state.propertyvalue = com.safeParseInt(propertyvalue)
        this.state.propertystate = this.app().property.state
        this.state.propertycounty = this.app().property.county
        this.state.currentbalance = com.safeParseInt(this.app().loanbalance)
        switch (this.app().property.purpose) {
            case "purchase": {
                const purchase = resolvePurchaseAmounts(this.app())
                this.state.loansize = purchase.loansize
                this.state.downpayment = this.state.defdownpayment = purchase.downpayment
                if (this.app().selection.selectedloan.hash !== "" || purchase.healDownpayment) {
                    this.persistSelectField(this.state.downpayment, "downpayment")
                }
                break
            }
            case "refinance":

                if (this.app().selection.selectedloan.hash !== "") {
                    this.state.loansize = this.app().selection.loansize
                    this.state.downpayment = this.state.defdownpayment = com.safeParseInt(this.app().loanbalance) - this.state.loansize
                } else {
                    this.state.downpayment = com.safeParseInt(this.app().selection.paydown)
                    this.state.defdownpayment = com.safeParseInt(this.app().selection.paydown)
                    this.state.loansize = com.safeParseInt(this.app().loanbalance) - com.safeParseInt(this.app().selection.paydown)
                }
                if (this.state.downpayment < 0 || this.state.downpayment > this.state.currentbalance) {
                    this.state.downpayment = this.state.defdownpayment = Math.max(0, Math.min(this.state.downpayment, this.state.currentbalance))
                    this.state.loansize = Math.max(0, this.state.currentbalance - this.state.downpayment)
                }
                if (this.app().selection.selectedloan.hash !== "") {
                    this.persistSelectField(this.state.downpayment, "paydown")
                }
                break;
            case "cashoutrefinance":

                this.state.lmincashout = this.app().selection.selectedloan.min
                if (this.app().selection.selectedloan.hash !== "") {
                    this.state.loansize = this.app().selection.loansize
                    this.state.downpayment = this.state.defdownpayment = this.state.loansize - com.safeParseInt(this.app().loanbalance)
                    if (this.state.downpayment <= 0) {
                        this.state.downpayment = this.state.defdownpayment = 30000
                    }
                    this.persistSelectField(this.state.downpayment, "cashout")
                } else {
                    this.state.downpayment = com.safeParseInt(this.app().selection.cashout)
                    this.state.defdownpayment = com.safeParseInt(this.app().selection.cashout)
                    this.state.loansize = com.safeParseInt(this.app().loanbalance) + com.safeParseInt(this.app().selection.cashout)
                }
                break;
            default:
                // alert("should not see this!")
                break;
        }

        // this.persistSelectField(this.state.loansize.toString(), "loansize")
        this.downloadDTIspreadsheetRef = React.createRef();

        this.getTermOptions().forEach(term => {
            if (this.app().selection.loanterms.includes("year"+term.value))
                this.state.termselected.push(term.value)
        })
        if (this.state.termselected.length === 0)
            this.state.termselected = [this.getTermOptions()[0].value]


        typeoptions.forEach(typ => {
            if (this.app().selection.loanamortizations.includes(typ.value))
                this.state.typeselected.push(typ.value)

        })
        if (this.state.typeselected.length === 0)
            this.state.typeselected = ['all']; // typeoptions.map((x) => x.value);
        this.cull = (a) => a
        this.selectsort(this.app().selection.sortby)

        this.width = 250

        this.isPrequal = this.app().property.purpose==="purchase" && this.app().property.hascontract===false
        this.height = Math.floor((this.width / 2) * Math.tan(3.14 / 3.0))
        if (this._v2Loaded && this.app().property.salesprice === "") {
            this.state.redirect = <Redirect to="/app/interview/main?section=start" />
        }
        this.rawproducts = []
        this.checkStatus()
        this.getLoanLimits()
        // backup
        this.loanbalance = this.state.loansize.toString()
        this.down = this.state.defdownpayment

        this.amortizations = [...this.app().selection.loanamortizations]
        this.terms = [...this.app().selection.loanterms]

        /* unit test!
                let l = ChosenLoan.fromJson(this.app().selection.selectedloan)
                l.hash = "ho ho ho" 
                this.persistSelectField(l, "selectedloan") 
        */
    }

    app() {
        return this.state?.v2View || this._v2View || emptyProductPickerView()
    }

    openClosingCostDetails = (card, detailType = "selected") => {
        const detailedCard = cardForClosingCostDetails(card, this.app().selection?.estimatedclosingcosts)
        this.setState({ detailedCard, detailType, show: true })
    }

    // Monthly income / debts for pricing: the DTI engine on the V2 application
    // (same numbers as the loan header). Zero until the application loads.
    // ignoreEstimator: the 1003's taxes / insurance / dues, not the calculator's saved estimate.
    dtiInputs = ({ ignoreEstimator = false } = {}) => (this._v2Application && computePricingInputs(this._v2Application, this.props.dtiSettings, { ignoreEstimator })) || { income: 0, liabilities: 0 }

    // What the Liabilities box is made of: the current DTI settings, 1003 amounts only after a reset.
    liabilitiesBreakdown = () => {
        const application = this._v2Application
        if (!application) return null
        const settings = this.props.dtiSettings
        const ignoreEstimator = this.state.liabilitiesFrom1003
        const cache = this._liabilitiesBreakdownCache
        if (cache && cache.application === application && cache.settings === settings && cache.ignoreEstimator === ignoreEstimator) return cache.result
        const result = computePricingLiabilities(application, settings, { ignoreEstimator })
        this._liabilitiesBreakdownCache = { application, settings, ignoreEstimator, result }
        return result
    }

    applyV2Application = (application, options = {}) => {
        let view = adaptV2ToProductPickerView(application)
        // Display-only: align selectedloan.purpose/funds with property.purpose in
        // memory so Rate / Fee Sheet labels match 1003. Does not persist.
        view = alignSelectedLoanPurpose(view).view
        this._v2Application = application
        this._v2View = view
        this._v2Loaded = true
        const purpose = view.property.purpose
        this.amortizations = [...(view.selection.loanamortizations || [])]
        this.terms = [...(view.selection.loanterms || [])]
        this.isPrequal = purpose === "purchase" && view.property.hascontract === false

        // Selection-only patches (e.g. See rates → prepaiddays) must match legacy:
        // update selection/view, but do not reset local Rate Recommendation filters
        // (income, liabilities, fico, property fields, loan size, etc.).
        if (options.skipReload) {
            this.setState({
                v2View: view,
                loadingApplication: false,
            })
            if (this.props.onApplicationChange) this.props.onApplicationChange(application)
            return
        }

        const propertyvalue = view.property.purpose === "purchase" ? view.property.salesprice : view.property.appraisal
        let downpayment = this.state.downpayment
        let defdownpayment = this.state.defdownpayment
        let loansize = this.state.loansize
        let currentbalance = com.safeParseInt(view.loanbalance)
        if (purpose === "purchase") {
            const purchase = resolvePurchaseAmounts(view)
            loansize = purchase.loansize
            downpayment = defdownpayment = purchase.downpayment
            if (view.selection.selectedloan.hash || purchase.healDownpayment) {
                this.persistSelectField(downpayment, "downpayment")
            }
        } else if (purpose === "refinance") {
            if (view.selection.selectedloan.hash) {
                loansize = com.safeParseInt(view.selection.loansize)
                downpayment = defdownpayment = currentbalance - loansize
            } else {
                downpayment = defdownpayment = com.safeParseInt(view.selection.paydown)
                loansize = currentbalance - downpayment
            }
            // Stale paydown (e.g. after clearing current balance) must not yield a
            // negative loan amount or paydown above the balance in the rate filters.
            if (downpayment < 0 || downpayment > currentbalance) {
                downpayment = defdownpayment = Math.max(0, Math.min(downpayment, currentbalance))
                loansize = Math.max(0, currentbalance - downpayment)
            }
        } else if (purpose === "cashoutrefinance") {
            if (view.selection.selectedloan.hash) {
                loansize = com.safeParseInt(view.selection.loansize)
                downpayment = defdownpayment = loansize - currentbalance
                if (downpayment <= 0) downpayment = defdownpayment = 30000
            } else {
                downpayment = defdownpayment = com.safeParseInt(view.selection.cashout)
                loansize = currentbalance + downpayment
            }
        }
        this.setState({
            v2View: view,
            loadingApplication: false,
            fico: view.scre || this.state.fico,
            firstTimeHomeBuyer: view.firsttimebuyer,
            propertytype: view.property.propertytype === "mobilehome" ? "manufacturedhome" : view.property.propertytype,
            propertyvalue: com.safeParseInt(propertyvalue),
            propertystate: view.property.state,
            propertycounty: view.property.county,
            currentbalance,
            downpayment,
            defdownpayment,
            loansize,
            ...this.dtiInputs(),
            liabilitiesFrom1003: false,
            redirect: "",
        }, () => {
            if (purpose !== "purchase" && purpose !== "cashoutrefinance" && purpose !== "refinance") {
                this.showModal()
            }
            this.getFeeConfig()
        })
        if (this.props.onApplicationChange) this.props.onApplicationChange(application)
    }

    loadV2Application = async () => {
        if (!this.props.loanid) {
            this.setState({ loadingApplication: false, loading: false })
            return
        }
        try {
            const body = await getLosApplicationV2(this.props.loanid)
            this.applyV2Application(body.Application)
        } catch (err) {
            console.error(err)
            this.setState({ loadingApplication: false, loading: false })
        }
    }

    persistSelectFields = (fields) => {
        const loanId = this.props.loanid
        const view = this.app()
        const selection = { ...(view.selection || {}) }
        const payload = {}
        Object.entries(fields || {}).forEach(([verb, input]) => {
            selection[verb] = input
            payload[verb] = `${input}`
        })
        const nextView = { ...view, selection }
        this._v2View = nextView
        this.setState({ v2View: nextView })
        if (!this._v2Loaded || !loanId || Object.keys(payload).length === 0) return
        patchSelectionV2(loanId, payload).then((body) => {
            if (body?.Application) this.applyV2Application(body.Application, { skipReload: true })
        }).catch((err) => console.error(err))
    }

    persistSelectionPatch = (payload, verb, input) => {
        const loanId = this.props.loanid
        const view = this.app()
        const selection = { ...(view.selection || {}) }
        if (verb) selection[verb] = input
        const nextView = { ...view, selection }
        this._v2View = nextView
        this.setState({ v2View: nextView })
        if (!this._v2Loaded || !loanId || !payload || Object.keys(payload).length === 0) return
        patchSelectionV2(loanId, payload).then((body) => {
            if (body?.Application) this.applyV2Application(body.Application, { skipReload: true })
        }).catch((err) => console.error(err))
    }

    persistSelectField = (input, verb) => {
        const loanId = this.props.loanid
        const view = this.app()
        const selection = { ...(view.selection || {}) }
        const nextView = { ...view, selection }
        if (verb === "loSelectedLoans") {
            selection.loSelectedLoans = input || []
            this._v2View = nextView
            this.setState({ v2View: nextView })
            if (loanId) patchLosRecommendedRatesV2(loanId, selection.loSelectedLoans).then((body) => {
                if (body?.Application) this.applyV2Application(body.Application, { skipReload: true })
            }).catch((err) => console.error(err))
            return
        }
        if (verb === "selectedloan") {
            selection.selectedloan = input || { hash: "" }
            this._v2View = nextView
            this.setState({ v2View: nextView })
            if (loanId) patchLosSelectedLoanV2(loanId, selection.selectedloan).then((body) => {
                if (body?.Application) this.applyV2Application(body.Application, { skipReload: true })
            }).catch((err) => console.error(err))
            return
        }
        if (["downpayment", "loansize", "paydown", "cashout"].includes(verb)) {
            this.persistSelectFields({ [verb]: input })
            return
        }
        if (verb === "estimatedclosingcosts") {
            this.persistSelectionPatch({ estimatedClosingCosts: input }, verb, input)
            return
        }
        if (["loanterms", "loanamortizations", "sortby", "prepaiddays", "mincashout"].includes(verb)) {
            const payload = verb === "mincashout" ? { [verb]: `${input}` } : { [verb]: input }
            this.persistSelectionPatch(payload, verb, input)
            return
        }
        selection[verb] = input
        this._v2View = nextView
        this.setState({ v2View: nextView })
    }

    persistPropertyField = (value, verb) => {
        const view = this.app()
        const property = { ...view.property, [verb]: value }
        const nextView = { ...view, property }
        this._v2View = nextView
        this.setState({ v2View: nextView })
        if (this.props.loanid) {
            patchPropertyFieldsV2(this.props.loanid, { [verb]: `${value}` }).then((body) => {
                if (body?.Application && this.props.onApplicationChange) this.props.onApplicationChange(body.Application)
            }).catch((err) => console.error(err))
        }
    }

    persistSelectedLoanField = (input, verb) => {
        const selectedloan = { ...(this.app().selection.selectedloan || {}), [verb]: input }
        this.persistSelectField(selectedloan, "selectedloan")
    }

    persistApplicationAttribute = (input, verb) => {
        if (verb === "loanbalance" && this.props.loanid) {
            const nextView = { ...this.app(), loanbalance: `${input}` }
            this._v2View = nextView
            this.setState({ v2View: nextView })
            patchLoanFieldsV2(this.props.loanid, { loanbalance: `${input}` }).catch((err) => console.error(err))
        }
    }

    reset = () => {

        let termselected = []
        let typeselected = []
        this.persistSelectField(this.terms, "loanterms")
        this.persistSelectField(this.amortizations, "loanamortizations")

        this.getTermOptions().forEach(term => {
            if (this.terms.includes("year"+term.value))
                termselected.push(term.value)
        })
        if (termselected.length === 0)
            termselected = [this.getTermOptions()[0].value]

        typeoptions.forEach(typ => {
            if (this.amortizations.includes(typ.value))
                typeselected.push(typ)

        })
        if (typeselected.length === 0)
            typeselected = typeoptions.map(x => x.value)

        this.setState({ termselected, typeselected }, () => {
            this.processProducts(this.rawproducts);
            this.forceUpdate()
        }
        )
    }
    getFees = getFees.bind(this)
    getDTI = getDTI.bind(this)
    getCitizenship = getCitizenship.bind(this)
    getOccupancy = getOccupancy.bind(this)
    getPropertyType = getPropertyType.bind(this)
    productReload = productReload.bind(this)
    getLTV = getLTV.bind(this)
    
    compareRate = (a, b) => {
        if (a.base_rate !== b.base_rate)
            return a.base_rate - b.base_rate

        return a.closing_cost - b.closing_cost // take into account remaining credits
    }

    cullRate = products => {
        if (products.length === 0)
            return products

        let newproducts = []
        newproducts.push(products[0])
        let base_rate = products[0].base_rate
        let counter = 0
        for (let i = 1; i < products.length; i++) {
            if (products[i].base_rate !== base_rate) {
                newproducts.push(products[i])
                base_rate = products[i].base_rate
                counter = 1
            } else {


                counter += 1
                if (counter < 5) {
                    newproducts.push(products[i])
                    base_rate = products[i].base_rate
                }
            }
        }
        return newproducts
    }
    compareAPR = (a, b) => {
        if (a.APR !== b.APR)
            return a.APR - b.APR
        if (a.base_rate !== b.base_rate)
            return a.base_rate - b.base_rate
        return a.closing_cost - b.closing_cost
    }
    cullAPR = products => {
        if (products.length === 0)
            return products
        let newproducts = []
        newproducts.push(products[0])
        let APR = products[0].APR
        for (let i = 1; i < products.length; i++) {
            if (products[i].APR !== APR) {
                newproducts.push(products[i])
                APR = products[i].APR
            } else {
            }
        }
        return newproducts
    }
    compareMoneyUpfront = (a, b) => {
        let acc = this.getClosingCosts(a)
        let bcc = this.getClosingCosts(b)
        if (acc !== bcc)
            return acc - bcc
        return a.base_rate - b.base_rate
    }

    cullMoneyUpfront = products => {
        if (products.length === 0)
            return products

        let newproducts = []
        newproducts.push(products[0])
        let closing_cost = this.getClosingCosts(products[0])
        for (let i = 1; i < products.length; i++) {
            if (this.getClosingCosts(products[i]) !== closing_cost) {
                newproducts.push(products[i])
                closing_cost = this.getClosingCosts(products[i])
            } else {
            }
        }
        return newproducts
    }

    compareMonthly = (a, b) => {
        if (a.monthly_payment !== b.monthly_payment)
            return a.monthly_payment - b.monthly_payment
        return a.closing_cost - b.closing_cost
    }

    cullMonthly = (products) => {
        if (products.length === 0)
            return products

        let newproducts = []
        newproducts.push(products[0])
        let monthly_payment = products[0].monthly_payment
        for (let i = 1; i < products.length; i++) {
            if (products[i].monthly_payment !== monthly_payment) {
                newproducts.push(products[i])
                monthly_payment = products[i].monthly_payment
            } else {
            }
        }
        return newproducts
    }
    compareTotalOwnership = (a, b) => {
        let loansize = com.safeParseInt(this.state.loansize)
        let ca = com.getClosedInterestPaid(0.01 * a.base_rate, loansize, a.Term, a.Term) //+ a.closing_cost
        let cb = com.getClosedInterestPaid(0.01 * b.base_rate, loansize, b.Term, b.Term) //+  b.closing_cost

        if (ca !== cb)
            return ca - cb

        return a.base_rate - b.base_rate
    }
    cullTotalOwnership = (products) => {
        if (products.length === 0)
            return products

        let getCost = a => {
            let loansize = com.safeParseInt(this.state.loansize)
            return com.getClosedInterestPaid(0.01 * a.base_rate, loansize, a.Term, a.Term) //+ a.closing_cost            
        }
        let newproducts = []
        newproducts.push(products[0])
        let cost = getCost(products[0])

        for (let i = 1; i < products.length; i++) {
            if (cost !== getCost(products[i])) {
                newproducts.push(products[i])
                cost = getCost(products[i])
            } else {
            }
        }
        return newproducts
    }

    compareHoldingOwnership = (a, b) => {
        let loansize = com.safeParseInt(this.state.loansize)
        let ca = com.getClosedInterestPaid(0.01 * a.base_rate, loansize, a.Term, this.state.yearstohold) // + a.closing_cost
        let cb = com.getClosedInterestPaid(0.01 * b.base_rate, loansize, b.Term, this.state.yearstohold) // +  b.closing_cost

        if (ca !== cb)
            return ca - cb

        return a.base_rate - b.base_rate
    }

    cullHoldingOwnership = (products) => {
        if (products.length === 0)
            return products

        let getCost = a => {
            let loansize = com.safeParseInt(this.state.loansize)
            return com.getClosedInterestPaid(0.01 * a.base_rate, loansize, a.Term, this.state.yearstohold) + a.closing_cost
        }
        let newproducts = []
        newproducts.push(products[0])
        let cost = getCost(products[0])

        for (let i = 1; i < products.length; i++) {
            if (cost !== getCost(products[i])) {
                newproducts.push(products[i])
                cost = getCost(products[i])
            } else {
            }
        }
        return newproducts
    }

    askedForAssistance = () => {
        return true === this.app().askedforassistance && this.app().property.purpose === "purchase"
    }
    getFeeConfig = () => {
        if(!this.props.borrowerid) {
            return;
        }
        let token = sessionStorage.getItem("ZeitroA")
        fetch('/data/getFees', {
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
                "X-Borrower": this.props.borrowerid,
            },
        }).then(
            response => {
                if (response.status !== 200) {
    
                    this.setState({
                        loading: false
                    })
                    return;
                }
                response.json().then(_fees => {
    
                    let f = new fees(_fees)
                    f.cannotshopservices = _fees.cannotshopservices
                    f.canshopservices = _fees.canshopservices
                    f.closingcostsfinanced = _fees.closingcostsfinanced
                    f.deposit = _fees.deposit
                    f.downpayment = _fees.downpayment
                    f.fundsforborrower = _fees.fundsforborrower
                    f.initialescrowpaymentsatclosing = _fees.initialescrowpaymentsatclosing
                    f.othercosts = _fees.othercosts
                    f.prepaids = _fees.prepaids
                    f.recordingandgovernmentfees = _fees.recordingandgovernmentfees
                    f.transfertax = _fees.transfertax
                    f.sellerscredits = _fees.sellerscredits
                    f.adjustmentsothercredits = _fees.adjustmentsothercredits
                    if (_fees && _fees.Error == null && _fees.Status !== "Error") {
                        this.persistSelectField(f, "estimatedclosingcosts")
                    }
                    this.setState({ loading: false })
                })
            }
    
        ).catch((err) => {
    
            this.setState({ loading: false })
        });
    }
    componentDidMount() {
        this.handleScroll()
        if (this.filtersWrapRef.current) {
            this.resizeObserver = new ResizeObserver(() => {
                this.handleScroll()
            })
            this.resizeObserver.observe(this.filtersWrapRef.current)
        }
        this.loadV2Application()
    }
    componentWillUnmount() {
        if (this.resizeObserver && this.filtersWrapRef.current) {
            this.resizeObserver.unobserve(this.filtersWrapRef.current)
            this.resizeObserver.disconnect()
        }
    }

    filterForAssistance = products => {
        let out = []
        products.forEach(x => {
            if (["RocketPro", "Plaza"].includes(x.Lender)) {
                out.push(x)
            }
        })
        return out
    }

    updateLender = (lender) => {
        let found = false
        this.lenders.forEach(x => {
            if (x === lender) {
                found = true
            }
        })
        if (found)
            return
        this.lenders.push(lender)
        this.setState({ selectedlenders: ['all'], lenders: this.lenders})
    }
    updateMtype = (mtype) => {
        let foundmtype = false
        this.mtypes.forEach(x => {
            if (x === mtype) {
                foundmtype = true
            }
        })
        if (foundmtype)
            return
        this.mtypes.push(mtype)

        this.setState({selectedmtypes: ['all'], mtypes: this.mtypes })
    }
    updateIncomeDocType = (incomedoctypes) => {
        const newIncomeDocTypes = incomedoctypes.filter(type => !this.incomedoctypes.includes(type));
        if (newIncomeDocTypes.length === 0) {
            return;
        }
        this.incomedoctypes = [...new Set([...this.incomedoctypes, ...newIncomeDocTypes])];
        this.setState({
            selectedincomedoctypes: ['all'],
            incomedoctypes: this.incomedoctypes
        });
    }
    isUncheckedLender = (lender) => {
        if (this.state.selectedlenders.includes('all')) {
            return false; // 如果选择了 'all', 则没有未选中的
        }
        let foundlender = false;
        this.state.selectedlenders.forEach((x) => {
            if (x === lender) {
                foundlender = true;
            }
        });
        return !foundlender;
    }
    isUncheckedMtype = (mtype) => {
        if (this.state.selectedmtypes.includes('all')) {
            return false; // 如果选择了 'all', 则没有未选中的
        }
        let foundmtype = false;
        this.state.selectedmtypes.forEach((x) => {
            if (x === mtype) {
                foundmtype = true;
            }
        });
        return !foundmtype;
    }
    isUncheckedIncomeDocType = (incomedoctypes) => {
        if (this.state.selectedincomedoctypes.includes('all')) {
            return false; // 如果选择了 'all', 则没有未选中的
        }
        // 确保 incomedoctypes 是一个数组
        const typesToCheck = Array.isArray(incomedoctypes) ? incomedoctypes : [incomedoctypes];
        return !typesToCheck.some((docType) =>
            this.state.selectedincomedoctypes.includes(docType)
        );
    }
    processProducts = (products) => {
        if ("undefined" === typeof products || products.length === 0)
            return
        this.rawproducts = products
        let rearranged = []

        let mintotalinterest = 100000000
        let maxtotalinterest = 0
        let maxreserves = 0
        let _types = this.state.typeselected.includes('all') ? typeoptions.map(x => x.value) : [...this.state.typeselected];
        let _terms = this.state.termselected.includes('all') ? this.getTermOptions().map(x => x.value) : [...this.state.termselected];
        let _totalterms = []
        products.forEach(product => {
            let lender = product.Lender
            this.updateLender(lender)
            if (this.isUncheckedLender(lender))
                return
            product.ProductRatesCosts.forEach(pr => {
                let commonproduct = pr.product
                let ausengine = pr.AUSEngine
                let mtype = pr.product.Mtype

                if ((this.app().borrower.declarations?.servearmedforces || "") !== "yes" && mtype === "VA")  {
                    return
                }

                this.updateMtype(mtype)
                if (this.isUncheckedMtype(mtype))
                    return
                this.updateIncomeDocType(commonproduct.IncomeDocTypes)
                if (this.isUncheckedIncomeDocType(commonproduct.IncomeDocTypes))
                    return
                pr.rateCosts.forEach(rate => {
                    if (!_totalterms.includes(com.safeParseInt(commonproduct.Term))) {

                        _totalterms.push(com.safeParseInt(commonproduct.Term))
                    }

                    if (_terms.includes(com.safeParseInt(commonproduct.Term))) {
                        let typ = commonproduct.Arm
                        if (typ === null || typeof typ === "undefined")
                            typ = "fixed"
                        else
                            typ = "arm" + typ.fixedperiod + "6"
                        // filter out non-30 day locks
                        if (rate.lockDay !== 30)
                            return

                        if (_types.includes(typ)) {

                            let cc = rate.closing_cost // + rate.prepaid_interest
                            let interest = com.getClosedInterestPaid(0.01 * rate.base_rate, com.safeParseInt(this.state.loansize), commonproduct.Term,
                                this.state.yearstohold)

                            if (interest > maxtotalinterest)
                                maxtotalinterest = interest
                            if (interest < mintotalinterest)
                                mintotalinterest = interest
                            if (rate.min_months_reserves > maxreserves)
                                maxreserves = rate.min_months_reserves
                        } else {
                        }
                    } else {
                    }
                    let pdkt = {
                        Lender: lender,
                        ...commonproduct,
                        Aus: ausengine,
                        ...rate
                    }

                    rearranged.push(pdkt)
                })
            })
        });


        this.setState({ maxreserves })

        if (this.state.selectedmaxreserves < 0 || this.state.selectedmaxreserves > maxreserves) {
            this.setState({ selectedmaxreserves: maxreserves })
        // eslint-disable-next-line react/no-direct-mutation-state           
            this.state.selectedmaxreserves = maxreserves
        }




        this.setState({
            mintotalinterest: mintotalinterest, maxtotalinterest: maxtotalinterest
        })


        let terms = []
        rearranged.forEach(pr => {
            let term = pr.Arm ? pr.Arm.fixedperiod : "fixed"
            if (!terms.includes(term))
                terms.push(term)
        })

        // Lender, Name
        let plainproducts = []
        this.referi = {}
        rearranged.forEach(pr => {
            if (pr.lockDay !== 30)
                return
            
            const { Lender, Name, Aus, lenderinfo, features, DTI, high_cost_loan, high_priced_loan, ...partialObject } = pr;

            let hsh = hash(partialObject)
            if (typeof this.referi[hsh] === "undefined") {
                plainproducts.push({ hash: hsh, ...partialObject })
                this.referi[hsh] = [{ Lender: Lender, Name: Name, Aus: Aus, LenderInfo: lenderinfo, Rate: partialObject }]
            } else {
                
                this.referi[hsh].push({ Lender: Lender, Name: Name, Aus: Aus, LenderInfo: lenderinfo, Rate: partialObject })
            }
        })

        this.products = plainproducts
        this.filter()
        
        // this.getSelectedIcon(this.app().selection.selectedloan)
        // if (!this.changeshown) {
        //     if (this.app().selection.selectedloan == null ||
        //         this.app().selection.selectedloan.hash === "" ) {

        //     } else {
        //         if (this.referi[this.app().selection.selectedloan.hash] == null) {
        //             let suggestedLoan = this.findClosestLoan()
        //             this.setState({showPriceChanged: true, suggestedLoan})
        //         }
        //     }
        //     this.changeshown = true
        // }

    }
    getSelectedIcon = (selectedloan) => {
        // prep the logo for the selected loan
        if (selectedloan != null && selectedloan.hash !== "") {
            let lenders = this.referi[selectedloan.hash]

            if (lenders != null) {
                let lender = lenders[0]

                let src = "/loan.png"
                let image = <img alt="lender" height={24} style={{ height: '24', width: 'auto' }} className="mr-2" src={src}></img>
                this.setState({ selectedImage: image, needsAdjustment: false })
            } else {
                if (selectedloan.loansize !== this.state.loansize) {
                    // keep old
                } else {
                    let src = "/pricingchange.png"
                    let image = <Link onClick={this.onPriceChange}><img alt="ho ho ho" height={24} style={{ height: '24', width: 'auto' }} className="mr-2 oscillate" src={src}></img> </Link>
                    this.setState({ selectedImage: image, needsAdjustment: true })
                }
            }

        } else {
            let src = "/pricingchange.png"
            let image = <Link onClick={this.onPriceChange}><img alt="ho ho ho" height={24} style={{ height: '24', width: 'auto' }} className="mr-2 oscillate" src={src}></img> </Link>
            this.setState({ selectedImage: image, needsAdjustment: true })
        }
    }
    findClosestLoan = () => {
        let loan = this.app().selection.selectedloan
        let nextbest = null
        if(this.products.length === 0) {
            return
        }
        console.log(this.products)
        this.products.forEach(p => {
            if (p.base_rate !== loan.base_rate)
                return
            if (p.Term !== loan.Term)
                return
            if (loan.ARM != null) {
                if (p.ARM == null)
                    return
                if (loan.ARM.fixedperiod !== p.ARM.fixedperiod)
                    return
            }
            if (nextbest == null) {
                nextbest = p
                return
            }
            if (nextbest.closing_cost < 0 && p.closing_cost > 0)
                return
            if (nextbest.closing_cost < 0 && p.closing_cost < 0) {
                if (nextbest.closing_cost > p.closing_cost) {
                    nextbest = p
                    return
                }
            } else {
                if (nextbest.closing_cost > 0 && p.closing_cost > 0) {
                    if (nextbest.closing_cost > p.closing_cost) {
                        nextbest = p
                        return
                    }
                } else {
                    if (nextbest.closing_cost > 0 && p.closing_cost <= 0) {
                        nextbest = p
                        return
                    }
                }
            }
        })

        let suggested = new ChosenLoan()
        suggested.hash = nextbest.hash

        suggested.APR = nextbest.APR
        if (nextbest.Arm !== null)
            suggested.Arm = nextbest.Arm
        suggested.amortization = nextbest.MortgageAmortization
        suggested.Mtype = nextbest.Mtype
        suggested.Term = nextbest.Term
        suggested.base_rate = nextbest.base_rate
        suggested.closing_cost = nextbest.closing_cost
        suggested.features = nextbest.features
        suggested.high_cost_mortgage = nextbest.high_cost_mortgage
        suggested.lender_credit = nextbest.lender_credit
        suggested.lender_fee = nextbest.lender_fee
        suggested.lockDay = nextbest.lockDay
        suggested.min_months_reserves = nextbest.min_months_reserves
        suggested.monthly_payment = nextbest.monthly_payment
        suggested.prepaid_interest = nextbest.prepaid_interest
        suggested.points = nextbest.points
        suggested.pmi = nextbest.PMICost
        suggested.FHAMIP = nextbest.FHAMIP
        suggested.DTI = nextbest.DTI
        suggested.matchingproducts = []
        suggested.loansize = loan.loansize
        suggested.purpose = this.app().property.purpose
        suggested.ourfee = nextbest.zeitro_fee
        suggested.prepaiddays = this.prepaid_interest_days
        suggested.downpayment = loan.downpayment
        suggested.paydown = loan.paydown
        suggested.checkout = loan.checkout
        suggested.aus = loan.aus        
        suggested.matchingproducts = []
        if(nextbest.maxcachout != null)
            suggested.maxcashout = nextbest.maxcashout

        this.referi[nextbest.hash].forEach(
            pr => {
                let l = new LoanProduct()

                l.Lender = pr.Lender
                l.Name = pr.Name
                l.lenderinfo = pr.LenderInfo
                l.aus = pr.Aus
                suggested.matchingproducts.push(l)
            }
        )
        // suggested.lender = lender2lender[suggested.matchingproducts[0].Lender]
        // preserve edits if they were already made
        if (loan != null && loan.estimatedclosingcosts != null) {
            suggested.estimatedclosingcosts = loan.estimatedclosingcosts
        } else {
            suggested.estimatedclosingcosts = this.app().selection.estimatedclosingcosts
        }
        return suggested
    }
    onPriceChange = () => {
        let suggestedLoan = this.findClosestLoan()
        this.setState({ showPriceChanged: true, suggestedLoan })

    }
    filter = () => {
        if (!this.products)
            return
        let types = this.state.typeselected.includes('all') ? typeoptions.map(x => x.value) : [...this.state.typeselected];
        let terms = this.state.termselected.includes('all') ? this.getTermOptions().map(x => x.value) : [...this.state.termselected];


        let filteredbyterm = this.products.filter(p => terms.includes(p.Term));

        let filteredbytype = filteredbyterm.filter(p => {
            let typ = p.Arm
            if (typ === null || typeof typ === "undefined")
                typ = "fixed"
            else
                typ = "arm" +  typ.fixedperiod + "6"
            return types.includes(typ)
        })
        // recalculate min and max here!



        let culled = this.cull(filteredbytype)
        //let top = filteredbyclosing.slice(0, 10)

        // culled.splice(this.howmany2display)
        let top = culled
        
        if(this.app().property.purpose ===  "cashoutrefinance" && this.app().selection.mincashout > 0) {
            if(parseInt(this.app().selection.cashout) < this.app().selection.mincashout) {
                
                this.setState({
                    errorText: <div className="mb-4 text-center"><h4 className='mt-5'>Minimum cashout size is ${com.commaizeFloat(this.app().selection.mincashout)}.
                    </h4><br />
                        <div style={{ fontSize: '1.5em' }} className="mb-3">Please increase the cashout size</div>
                        </div>, topProducts: []
                })       
                return         
            }
        }

        // 如果有targetprice，则产品按照targetprice排序 排序规则为 越靠近targetprice的数据越靠前
        if(Math.abs(this.state.targetprice) > 0) {
            let sorted_culled = culled.sort((a, b) => {
                return Math.abs(a.points - this.state.targetprice) - Math.abs(b.points - this.state.targetprice)
            })
            this.setState({ products:sorted_culled,  topProducts: top })
            // console.log("culled", culled, sorted_culled)
        }else{
            this.setState({ products:culled,  topProducts: top })
        }

        if (this.products && this.products.length > 0 && this.state.topProducts.length === 0) {
            this.setState({
                errorText: <div className="mb-4 text-center"><h4 className='mt-5'>There are no qualifying loan products that fit your filters.
                </h4>
                    {/* <div style={{ fontSize: '1.5em' }} className="mb-3">Move the range sliders, change the term/amortization selections, or</div>
                    <Button onClick={this.resetDefault} > <div style={{ fontSize: '1.4em' }}>Click to reset filters to default </div></Button>  */}
                    </div>
            })
        }

    }

    resetDefault = () => {
        let termselected = [this.getTermOptions()[0].value]

        let typeselected = []
        typeoptions.forEach(typ => {
            typeselected.push(typ.value)
        })
        this.setState({ typeselected: ['all'], termselected })
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.processProducts(this.rawproducts)
            this.forceUpdate()
        }, 1000)
    }
    renderProducts = () => {
        return this.state.topProducts.map(this.displayCard)
    }
    onTriangleUpdate = (l1, l2) => {
        l1 = parseFloat(l1)
        l2 = parseFloat(l2)
        this.setState({ weightclosing: l2, weighttotalcost: l1, weightmonthly: Math.max(0.0, 1 - l2 - l1) })

        this.persistSelectField(l2, "weightclosing")
        this.persistSelectField(l1, "weighttotalcost")
        this.persistSelectField(Math.max(0.0, 1 - l2 - l1), "weightmonthly")

        this.filter()
    }

    updateTerms = e => {
        let out = []
        e.forEach(t => {
            out.push(t.id)
        })
        this.persistSelectField(out, "loanterms")
    }
    onDeselectAmortization = (e) => {
        if (e === 'all') {
          this.onSelect([]);
        }else{
          this.onSelect(this.state.typeselected.filter(x => x !== e));
        }
    }
    onSelectAmortization = (e) => {
        if (e === 'all') {
            this.onSelect(['all']);
        } else {
            if(this.state.typeselected.includes('all')) {
                this.onSelect([...this.state.typeselected.filter(x => x !== 'all'), e])
            } else {
                this.state.typeselected.length + 1 === typeoptions.length ? this.onSelect(['all']) : this.onSelect([e, ...this.state.typeselected]);
            }
        }
    }
    onSelect = (e) => {
        this.state.typeselected = e;
        this.setState({ typeselected: e, isEditFilter: true });
        this.persistSelectField(e.includes('all') ? e.filter(x => x !== 'all') : e, "loanamortizations");
        this.processProducts(this.rawproducts);
        this.clearSelected();
        this.forceUpdate();
    };
    onSelectTermsWithAll = (value) => {
        if (value === 'all') {
          this.onSelectTerms(['all']);
        } else {
          const currentSelection = this.state.termselected;
          if (currentSelection.includes('all')) {
            this.onSelectTerms([value]);
          } else {
            const newSelection = [...currentSelection, value];
            if (newSelection.length === this.getTermOptions().length) {
              this.onSelectTerms(['all']);
            } else {
              this.onSelectTerms(newSelection);
            }
          }
        }
    }
    
    onDeselectTermsWithAll = (value) => {
        if (value === 'all') {
          this.onSelectTerms([]);
        } else {
          const currentSelection = this.state.termselected;
          if (currentSelection.includes('all')) {
            const newSelection = this.getTermOptions().map(opt => opt.value).filter(optValue => optValue !== value);
            this.onSelectTerms(newSelection);
          } else {
            const newSelection = currentSelection.filter(item => item !== value);
            this.onSelectTerms(newSelection);
          }
        }
    };

    onSelectIncomeDocTypesWithAll = (value) => {
        if (value === 'all') {
          this.onSelectIncomeDocTypes(['all']);
        } else {
          const currentSelection = this.state.selectedincomedoctypes;
          if (currentSelection.includes('all')) {
            this.onSelectIncomeDocTypes([value]);
          } else {
            const newSelection = [...currentSelection, value];
            // Check against the dynamically populated incomedoctypes list
            if (this.state.incomedoctypes && newSelection.length === this.state.incomedoctypes.length) {
              this.onSelectIncomeDocTypes(['all']);
            } else {
              this.onSelectIncomeDocTypes(newSelection);
            }
          }
        }
    };
    
    onDeselectIncomeDocTypesWithAll = (value) => {
        if (value === 'all') {
          this.onSelectIncomeDocTypes([]);
        } else {
          const currentSelection = this.state.selectedincomedoctypes;
          if (currentSelection.includes('all')) {
            // Use the dynamically populated incomedoctypes list
            const allIncomeDocTypes = this.state.incomedoctypes || [];
            const newSelection = allIncomeDocTypes.filter(docType => docType !== value);
            this.onSelectIncomeDocTypes(newSelection);
          } else {
            const newSelection = currentSelection.filter(item => item !== value);
            this.onSelectIncomeDocTypes(newSelection);
          }
        }
    };
    
    onSelectMortgageTypesWithAll = (value) => {
        if (value === 'all') {
          this.onSelectMortgageTypes(['all']);
        } else {
          const currentSelection = this.state.selectedmtypes;
          if (currentSelection.includes('all')) {
            this.onSelectMortgageTypes([value]);
          } else {
            const newSelection = [...currentSelection, value];
            // Check against the dynamically populated mtypes list
            if (this.state.mtypes && newSelection.length === this.state.mtypes.length) {
              this.onSelectMortgageTypes(['all']);
            } else {
              this.onSelectMortgageTypes(newSelection);
            }
          }
        }
    };
    
    onDeselectMortgageTypesWithAll = (value) => {
        if (value === 'all') {
          this.onSelectMortgageTypes([]);
        } else {
          const currentSelection = this.state.selectedmtypes;
          if (currentSelection.includes('all')) {
            // Use the dynamically populated mtypes list
            const allMtypes = this.state.mtypes || [];
            const newSelection = allMtypes.filter(mtype => mtype !== value);
            this.onSelectMortgageTypes(newSelection);
          } else {
            const newSelection = currentSelection.filter(item => item !== value);
            this.onSelectMortgageTypes(newSelection);
          }
        }
    };

    onSelectTerms = (e) => {
        this.state.termselected = e;
        this.setState({ termselected: e, isEditFilter: true });
        this.persistSelectField(
          e.map((x) => "year" + x),
          "loanterms"
        );
        this.processProducts(this.rawproducts);
        this.clearSelected();
        this.forceUpdate();
    }
    onSelectLendersWithAll = (value) => {
        if (value === 'all') {
          this.onSelectLenders(['all']);
        } else {
          const currentSelection = this.state.selectedlenders;
          if (currentSelection.includes('all')) {
            this.onSelectLenders([value]);
          } else {
            const newSelection = [...currentSelection, value];
            // Check against the dynamically populated lenders list
            if (this.state.lenders && newSelection.length === this.state.lenders.length) {
              this.onSelectLenders(['all']);
            } else {
              this.onSelectLenders(newSelection);
            }
          }
        }
    }
    
    onDeselectLendersWithAll = (value) => {
        if (value === 'all') {
          this.onSelectLenders([]);
        } else {
          const currentSelection = this.state.selectedlenders;
          if (currentSelection.includes('all')) {
            // Use the dynamically populated lenders list
            const allLenders = this.state.lenders || [];
            const newSelection = allLenders.filter(lender => lender !== value);
            this.onSelectLenders(newSelection);
          } else {
            const newSelection = currentSelection.filter(item => item !== value);
            this.onSelectLenders(newSelection);
          }
        }
    };
    onSelectTargetPrice = (e) => {
        this.setState({ 
            targetprice: e,
            sortOrder: null,
            sortColumn: null 
        }, () => {
            this.processProducts(this.rawproducts)
            this.clearSelected()
            this.forceUpdate()
        })
    }
    onSelectMortgageTypes = (e) => {
        this.setState({ selectedmtypes: e, isEditFilter: true }, () => {
            // this.updateTerms(e)
            this.processProducts(this.rawproducts)
            this.forceUpdate()
        })
    }
    onSelectIncomeDocTypes = (e) => {
        this.setState({ selectedincomedoctypes: e, isEditFilter: true }, () => {
            this.processProducts(this.rawproducts)
            this.clearSelected()
            this.forceUpdate()
        })
    }
    onSelectLenders = (e) => {

        this.setState({ selectedlenders: e, isEditFilter: true }, () => {
            this.updateTerms(e)
            this.processProducts(this.rawproducts)
            this.clearSelected()
            this.forceUpdate()
        })
    }

    selectsort = e => {
        this.persistSelectField(e, "sortby")
        switch (e) {
            case "selectbyrate":
                this.compare = this.compareRate
                this.cull = this.cullRate
                break
            case "selectbyapr":
                this.compare = this.compareAPR
                this.cull = this.cullAPR
                break
            case "selectbyinterestterm":
                this.compare = this.compareHoldingOwnership
                this.cull = this.cullHoldingOwnership
                break
            case "selectbyinteresttotal":
                this.compare = this.compareTotalOwnership
                this.cull = this.cullTotalOwnership
                break
            case "selectbymonthlypayment":
                this.compare = this.compareMonthly
                this.cull = this.cullMonthly
                break
            case "selectbyclosingcosts":
                this.compare = this.compareMoneyUpfront
                this.cull = this.cullMoneyUpfront
                break

            default:
                break
        }
        this.filter()
        return
    }

    changeYears = e => {
        this.setState({ yearstohold: e })
        this.persistApplicationAttribute(com.safeParseInt(e), "keepinghousefor")
        return false
    }
    //--- begin callbacks that cause a reload
    updateDownpayment = e => {
        let dp = e
        if (isNaN(dp))
            return
        this.setState({ downpayment: com.safeParseInt(dp) })
        return false
    }
    changeDownpayment = e => {
        const dp = e ?? 0
        if (isNaN(dp))
            return
        let ls = this.state.propertyvalue - parseFloat(dp)
        this.setState({ downpayment: dp, loansize: ls, ltv: 100 * (ls) / this.state.propertyvalue, defdownpayment: dp })
    }

    changePaydown = e => {
        let dp = e ?? 0
        if (isNaN(dp))
            dp = 0

        let ls = com.safeParseInt(this.state.currentbalance) - parseFloat(dp)
        this.setState({ downpayment: com.safeParseInt(dp), loansize: ls, defdownpayment: dp })
                // eslint-disable-next-line react/no-direct-mutation-state
        this.state.loansize = ls
                // eslint-disable-next-line react/no-direct-mutation-state
        this.state.ltv = 100 * (com.safeParseInt(ls) / this.state.propertyvalue)
        return false
    }

    changeCashout = e => {
        let dp = e == null || e === "" ? 0 : com.safeParseInt(e)
        if (isNaN(dp)) dp = 0

        let ls = com.safeParseInt(this.state.currentbalance) + parseFloat(dp)
        this.setState({ downpayment: dp, loansize: ls, defdownpayment: dp })
                // eslint-disable-next-line react/no-direct-mutation-state
        this.state.ltv = 100 * (ls) / this.state.propertyvalue

        return false
    }

    changeIncome = e => {
        let dp = e ?? 0
        if (isNaN(dp))
            dp = 0
        this.setState({ income: dp })
    }
    changeLiabilities = e => {
        let dp = e ?? 0
        if (isNaN(dp))
            dp = 0
        this.setState({ liabilities: dp })
    }
    changeFico = e => {
        let dp = e ?? 0
        this.setState({ fico: dp })
    }
    changePropertyValue = e => {
        let dp = e ?? 0

        if (isNaN(dp))
            dp = 0
        if (this.app().property.purpose === "purchase") {
            // Use the down payment typed here, not the 1003 one, so editing both fields in either order agrees.
            let downpayment = com.safeParseInt(this.state.defdownpayment)
            let newLoansize = dp - downpayment
            if (newLoansize >= 0) {
                this.setState({ loansize: newLoansize, ltv: dp > 0 ? (100 * newLoansize) / dp : 0 })
            }
        }
        this.setState({ propertyvalue: dp })
    }
    changeCurrentBalance = e => {
        let dp = e ?? 0
        if (isNaN(dp))
            dp = 0
        let newLoansize = 0
        let defdownpayment = this.state.defdownpayment
        if (this.app().property.purpose === 'refinance') {
            // Keep paydown within the new balance so loan size cannot go negative.
            if (defdownpayment > dp) defdownpayment = Math.max(0, dp)
            newLoansize = Math.max(0, dp - defdownpayment)
        } else if (this.app().property.purpose === 'cashoutrefinance') {
            newLoansize = dp + defdownpayment
        }
        this.setState({ currentbalance: dp, loansize: newLoansize, downpayment: defdownpayment, defdownpayment })
    }
    changePropertyState = e => {
        this.setState({ propertystate: e, propertycounty: '' })
    }
    changePropertyCounty = e => {
        this.setState({ propertycounty: e })
    }
    updateReserves = e => {
        let [reserves] = e
        if (this.state.selectedmaxreserves < 0)
            return
        if (isNaN(reserves))
            reserves = this.state.maxreserves
        if (reserves !== this.state.selectedmaxreserves) {
            this.setState({ selectedmaxreserves: reserves })
        // eslint-disable-next-line react/no-direct-mutation-state
            this.state.selectedmaxreserves = reserves
        }

        this.filter()
    }
    changeReserves = e => {
        let [reserves] = e
        if (this.state.selectedmaxreserves < 0)
            return
        if (isNaN(reserves))
            reserves = this.state.maxreserves
        if (reserves !== this.state.selectedmaxreserves) {
            this.setState({ selectedmaxreserves: reserves })
        // eslint-disable-next-line react/no-direct-mutation-state
            this.state.selectedmaxreserves = reserves
        }

        this.filter()
    }

    removeSelection(hash) {
        let comparisonSelections = this.state.comparisonSelections
        delete comparisonSelections[hash]

        this.setState({ comparisonSelections })
    }
    // 合并 closingCostsDetail
    mergeClosingCostsDetail = (detail1, detail2) => {
        const fields = [
            'canNotShopServices',
            'canShopServices',
            'taxesAndOtherGovernmentFees',
            'originationCharges',
            'prepaids',
            'initialEscrowPaymentsAtClosing',
            'other'
        ]
        const merged = {}
        fields.forEach(field => {
            const arr1 = Array.isArray((detail1||{})[field]) ? (detail1||{})[field] : []
            const arr2 = Array.isArray((detail2||{})[field]) ? (detail2||{})[field] : []
            merged[field] = [...arr1, ...arr2].filter(Boolean)
        })
        return merged
    }
    selectLoan(hash) {
        let ob = this.referi[hash][0]
        let loan = new ChosenLoan()
        loan.hash = hash

        loan.APR = ob.Rate.APR
        if (ob.Rate.Arm !== null)
            loan.Arm = ob.Rate.Arm
        loan.amortization = ob.Rate.MortgageAmortization
        loan.Mtype = ob.Rate.Mtype
        loan.Term = ob.Rate.Term
        loan.base_rate = ob.Rate.base_rate
        loan.closing_cost = ob.Rate.closing_cost
        loan.features = ob.Rate.features
        loan.high_cost_mortgage = ob.Rate.high_cost_mortgage
        loan.lender_credit = ob.Rate.lender_credit
        loan.lender_fee = ob.Rate.lender_fee
        loan.lockDay = ob.Rate.lockDay
        loan.min_months_reserves = ob.Rate.min_months_reserves
        loan.monthly_payment = ob.Rate.monthly_payment
        loan.prepaid_interest = ob.Rate.prepaid_interest
        loan.points = ob.Rate.points
        loan.pmi = ob.Rate.PMICost
        loan.FHAMIP = ob.Rate.FHAMIP
        loan.DTI = ob.Rate.DTI
        loan.matchingproducts = []
        loan.loansize = this.state.loansize
        loan.purpose = this.app().property.purpose
        loan.ourfee = this.zeitro_fee
        loan.prepaiddays = this.prepaid_interest_days
        
        if(ob.Rate.max_cashout != null) {
            loan.maxcashout = ob.Rate.max_cashout
        }
        // Create a deep copy of estimatedclosingcosts
        if (this.app().selection.selectedloan != null && this.app().selection.selectedloan.estimatedclosingcosts != null) {
            loan.estimatedclosingcosts = JSON.parse(JSON.stringify(this.app().selection.selectedloan.estimatedclosingcosts))
        } else {
            loan.estimatedclosingcosts = JSON.parse(JSON.stringify(this.app().selection.estimatedclosingcosts))
        }
        
        loan.estimatedclosingcosts.closingCostsDetail = this.mergeClosingCostsDetail(this.state.closingCostsDetail, ob.Rate.closing_costs_detail);

        switch (this.app().property.purpose) {
            case "purchase":
                loan.downpayment = this.state.downpayment
                break;
            case "refinance":
                loan.paydown = this.state.downpayment
                break;
            case "cashoutrefinance":
                loan.cashout = this.state.downpayment
                break;
            default:
                break;
        }

        loan.aus = ob.Aus

        this.referi[hash].forEach(
            pr => {
                let l = new LoanProduct()

                l.Lender = pr.Lender
                l.Name = pr.Name
                l.lenderinfo = pr.LenderInfo
                l.aus = pr.Aus
                loan.matchingproducts.push(l)
            }
        )
        
        if (!this.app().selection.loSelectedLoans.some(l => l.hash === loan.hash)) {
            this.persistSelectField([...this.app().selection.loSelectedLoans, loan], "loSelectedLoans");
        }
    }
    notifyBorrower() {
        let token = sessionStorage.getItem("ZeitroA")
        const pathSegments = window.location.pathname.split('/');
        const loanid = pathSegments[pathSegments.length - 1];

        fetch('/los/notifyborroweraboutchosenrate', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "X-Borrower": this.props.borrowerid,
                "X-Loan": loanid,
            },
        }).then(
            response => {
                if (response.status !== 200) {
                    return
                } 
            }
        ).catch((err) => {
            
        });
    }
    recommendRates() {
        let finalSelected = []
        for (let rate of this.state.ratesToBeRecommended) {
            let hash = rate.hash
            let ob = this.referi?.[hash]?.[0]
            if (!ob?.Rate) continue
            let loan = new ChosenLoan()
            loan.hash = hash
    
            loan.APR = ob.Rate.APR
            if (ob.Rate.Arm !== null)
                loan.Arm = ob.Rate.Arm
            loan.amortization = ob.Rate.MortgageAmortization
            loan.Mtype = ob.Rate.Mtype
            loan.Term = ob.Rate.Term
            loan.base_rate = ob.Rate.base_rate
            loan.closing_cost = ob.Rate.closing_cost
            loan.features = ob.Rate.features
            loan.high_cost_mortgage = ob.Rate.high_cost_mortgage
            loan.lender_credit = ob.Rate.lender_credit
            loan.lender_fee = ob.Rate.lender_fee
            loan.lockDay = ob.Rate.lockDay
            loan.min_months_reserves = ob.Rate.min_months_reserves
            loan.monthly_payment = ob.Rate.monthly_payment
            loan.prepaid_interest = ob.Rate.prepaid_interest
            loan.points = ob.Rate.points
            loan.pmi = ob.Rate.PMICost
            loan.FHAMIP = ob.Rate.FHAMIP
            loan.DTI = ob.Rate.DTI
            loan.matchingproducts = []
            loan.loansize = this.state.searchParams.loansize
            loan.purpose = this.app().property.purpose
            loan.ourfee = this.zeitro_fee
            loan.prepaiddays = this.prepaid_interest_days
            
            if(ob.Rate.max_cashout != null) {
                loan.maxcashout = ob.Rate.max_cashout
            }
            const closingCosts = this.app().selection.selectedloan?.estimatedclosingcosts
                || this.app().selection.estimatedclosingcosts
                || {}
            loan.estimatedclosingcosts = typeof closingCosts.toJson === "function"
                ? JSON.parse(closingCosts.toJson())
                : JSON.parse(JSON.stringify(closingCosts))
            
            loan.estimatedclosingcosts.closingCostsDetail = this.mergeClosingCostsDetail(this.state.closingCostsDetail, ob.Rate.closing_costs_detail);
            switch (this.app().property.purpose) {
                case "purchase":
                    loan.downpayment = this.state.searchParams.defdownpayment
                    break;
                case "refinance":
                    loan.paydown = this.state.searchParams.defdownpayment
                    break;
                case "cashoutrefinance":
                    loan.cashout = this.state.searchParams.defdownpayment
                    break;
                default:
                    break;
            }
    
            loan.aus = ob.Aus
    
            ;(this.referi[hash] || []).forEach(
                pr => {
                    let l = new LoanProduct()
    
                    l.Lender = pr.Lender
                    l.Name = pr.Name
                    l.lenderinfo = pr.LenderInfo
                    l.aus = pr.Aus
                    loan.matchingproducts.push(l)
                }
            )
            finalSelected.push(loan)
        }

        const existing = Array.isArray(this.app().selection.loSelectedLoans)
            ? this.app().selection.loSelectedLoans
            : []
        const combinedSelected = finalSelected.concat(existing)
        const uniqueArray = combinedSelected.filter((item, index, array) =>
            array.findIndex(obj => obj.hash === item.hash) === index
        );
        this.persistSelectField(uniqueArray, "loSelectedLoans");


        this.setState({ showRecommendRatesModal: true, ratesToBeRecommended: [] })
        this.notifyBorrower()
    }
    selectCard = card => {
        com.touch()
        this.selectLoan(card.hash)
    }

    getOldInterestRate = () => {

        if (this.app().property.purpose !== st.POL_Refinance)
            return
        // just scan all the loans for rate
        // first regular loans from credit report
        let rate = 0
        for (let i = 0; i < this.app().assetsandliabilities.loans.length; i++) {
            if (this.app().assetsandliabilities.loans[i].forsubjectproperty &&
                this.app().assetsandliabilities.loans[i].satisfiedupon === "withproceeds") {
                rate = this.app().assetsandliabilities.loans[i].rate
            }
        }

        if (0 === rate) {
            if (this.app().otherliens !== null) {
                for (let i = 0; i < this.app().otherliens.length; i++) {
                    if (this.app().otherliens[i].satisfiedupon === "withproceeds") {
                        rate = this.app().otherliens[i].rate
                    }
                }
            }
        }
        return rate
    }
    scrollToLeft = () => {
        if (this.filtersWrapRef.current) {
            this.filtersWrapRef.current.scrollTo({
                left: 0,
                behavior: 'smooth',
            });
        }
    }
    scrollToRight = () => {
        if (this.filtersWrapRef.current) {
            this.filtersWrapRef.current.scrollTo({
                left: this.filtersWrapRef.current.scrollWidth,
                behavior: 'smooth',
            })
        }
    }
    handleScroll = () => {
        const container = this.filtersWrapRef.current
        if (container) {
            const { scrollLeft, scrollWidth, clientWidth } = container

            const isScrollable = scrollWidth > clientWidth
            this.setState({
                showLeftButton: isScrollable && scrollLeft > 0, 
                showRightButton: isScrollable && scrollLeft + clientWidth < scrollWidth,
            })
        }
    }
    displayCard = (card, index) => {

        let currentMonthly = com.getMonthlyValue(this.app().borrower.expenses.currentfirstmortgage,
            this.app().borrower.expenses.currentfirstmortgageperiod)
        let mostyle = {}
        if (card.monthly_payment > parseFloat(currentMonthly)) {
            mostyle = { color: '#c33' }
        } else {
            mostyle = { color: '#393' }
        }
        let showSavings = () => {

            if (this.app().property.purpose !== "refinance")
                return ""
            if (card.monthly_payment > parseFloat(currentMonthly)) {
                return <i className="ml-1 fas fa-arrow-up"></i>
            }
            return <i className="ml-1 fas fa-arrow-down"></i>
        }

        if (this.app().selection.selectedloan !== null && (this.app().selection.selectedloan.hash === card.hash))
            return ""
        let getName = () => {
            if (this.props.borrowerid && this.referi && this.referi[card.hash] != null) {
                let r = this.referi[card.hash][0]
                return r["Lender"] + ", " + r["Name"]
            }
            return com.capitalize(card.Mtype.replace('_', ' ').toLowerCase().replace('fha', 'FHA'))
        }
        let getType = () => {
            let tp = ""
            if (card.Arm == null )
                tp = "Fixed rate"
            else
                tp = "ARM " + card.Arm.fixedperiod + "/6"
            return tp
        }

        let selectCard = e => { return this.selectCard(card) }
        let fingerclass = "fas fa-hand-point-left mr-1"
        if (index === 0)
            fingerclass += " fingerclass"
        let points = com.commaizeFloat((card.points * com.safeParseInt(this.state.loansize) / 100).toFixed(2))
        let moPayment = () => {
            let payment = card.monthly_payment
            if (card.PMICost !== 0) {
                payment = payment + card.PMICost
            } else if (card.FHAMIP != null) {
                payment = payment + card.FHAMIP.monthlyMIP
            }
            payment = com.commaizeFloat(payment.toFixed(2))
            return payment
        }

        let getBreakPoint = (loan) => {
            let interestRate = this.getOldInterestRate()

            function getClosedInterestPaid(rate, loansize, termmonths, spanmonths) {

                let monthlyrate = rate / 12.0
                let expn = Math.pow(1 + monthlyrate, termmonths)
                let payment = loansize * monthlyrate * expn / (expn - 1)
                payment = (Math.round(payment * 100) / 100)

                let accumulatedinterest = (loansize * monthlyrate - payment) *
                    (Math.pow(1 + monthlyrate, spanmonths) - 1) / monthlyrate +
                    spanmonths * payment
                return accumulatedinterest
            }

            let breakPoint = -1
            if (parseFloat(interestRate) <= loan.base_rate) {
                return breakPoint
            }

            for (let i = 1; i <= loan.Term * 12; i++) {
                let accumulatedOld = getClosedInterestPaid(parseFloat(interestRate) / 100, this.state.loansize, loan.Term * 12, i)
                let accumulatedNew = getClosedInterestPaid(loan.base_rate / 100, this.state.loansize, loan.Term * 12, i)

                accumulatedNew += loan.closing_cost
                if (accumulatedNew < accumulatedOld) {
                    breakPoint = i
                    break
                }
            }
            return breakPoint
        }

        return (
            <Container key={card.hash} className="drop-shadow w-100 px-0 text-left pb-3">
                <Row className="bluishbackground text-left mt-3 mb-0 mx-0 py-2">
                    {/* <Col style={{alignItems:"center", paddingRight: '0px' }} xs="auto" className="d-flex text-center vertical-middle mx-0 ">
                        <Form.Group controlId="emailmethod" className="text-center d-block text-nowrap m-0 p-0" >
                            <Form.Check type="checkbox"
                                checked={this.state.comparisonSelections[card.hash] != null}
                                key={card.hash}
                                disabled={this.state.comparisonSelections[card.hash] == null && Object.keys(this.state.comparisonSelections).length >= 4}
                                onChange={oncheckbox}
                                style={{ textAlign: 'center', paddingRight: '0px', paddingLeft: '22px' }}
                                //className="p-0 m-0"
                                label=""
                            ></Form.Check>
                        </Form.Group>
                    </Col> */}
                    <Col style={{ alignItems:"center", fontWeight: 500 }} className="d-flex text-left ">
                        {getName()}
                        {this.props.borrowerid ? "" : <div>, {getType()}, {card.Term} years </div>}
                    </Col>
                    <Col xs={"auto"} className="text-right align-top loancard" >
                        <div className='d-flex'>
                        <Button size="sm" onClick={selectCard} variant="outline"><b>Choose rate</b></Button>
                        <Button size="sm" variant="link" className='pr-0 ml-0' onClick={() => this.openClosingCostDetails(card)}>
                            Cost Breakdown
                        </Button>
                        </div>
                    </Col>
                </Row>
                <Row className="text-left mt-0 mb-0 mx-0">

                    <Col xs={3} className=" loancard pt-2 ">
                        <div>Rate / APR</div>
                        <div>{card.base_rate}% / {card.APR}%</div>
                    </Col>
                    <Col xs={3} className=" loancard pt-2 ">
                        <div>Mo. Payment</div>
                        {this.app().property.purpose === "refinance" ? MonhtlyChangeBP(currentMonthly, card.monthly_payment, getBreakPoint(card),
                            <span style={mostyle} ><b>${moPayment()}</b>{showSavings()}</span>
                        ) : <b>${moPayment()}</b>}                    </Col>
                    <Col xs={3} className=" loancard pt-2 ">
                        <div>Estimated Closing Cost</div>
                        <b>${com.commaizeFloat((this.getClosingCosts(card)).toFixed(2))}</b>
                    </Col>
                    <Col xs={3} className=" loancard pt-2 ">
                        <div>Points</div>
                        {com.commaizeFloat(card.points.toFixed(3))}%{card.points <= 0 ? "" : <span>/${points}</span>}
                    </Col>
                </Row>
                <Row className="text-left mt-2 mb-0 mx-0 d-flow">

                    <Col className=" d-flow loancard" style={{ color: "#6E6E70" }}>
                        {card.PMICost !== 0 ? <span className="mr-3">Requires mortgage insurance ${com.commaizeFloat(card.PMICost)}/mo</span> : ""}

                        {com.safeParseInt(card.min_months_reserves) > 0 ?
                            <span className=" py-2  mr-3">
                                Reserves required: {card.min_months_reserves} months
                            </span> : ""}

                        {card.FHAMIP != null ?
                            <span className=" py-2  mr-3">
                                Upfront mortgage insurance premium: ${card.FHAMIP.upfrontMIP}, monthly insurance payment: ${com.commaizeFloat(card.FHAMIP.monthlyMIP)}
                            </span>
                            : ""}
                    </Col>

                </Row>

            </Container>
        )
    }

    resetTo1003Values = () => {
        let propertyvalue = this.app().property.purpose === "purchase"
        ? this.app().property.salesprice
        : this.app().property.appraisal;

        // 先准备要 setState 的对象
        let newState = {
            fico: this.app().scre,
            propertytype: this.app().property.propertytype,
            propertyvalue: com.safeParseInt(propertyvalue),
            propertystate: this.app().property.state,
            propertycounty: this.app().property.county,
            currentbalance: com.safeParseInt(this.app().loanbalance),
            firstTimeHomeBuyer: this.app().firsttimebuyer,
            // The 1003's own taxes / insurance / dues, not the calculator's saved estimate
            // (the loan header and the calculator keep using that).
            ...this.dtiInputs({ ignoreEstimator: true }),
            liabilitiesFrom1003: true,
            showFilterForm: this.state.isEditFilter
        };

        // 处理贷款相关字段
        let downpayment, defdownpayment, loansize;
        switch (this.app().property.purpose) {
            case "purchase": {
                const purchase = resolvePurchaseAmounts(this.app())
                loansize = purchase.loansize
                downpayment = defdownpayment = purchase.downpayment
                this.persistSelectField(downpayment, "downpayment");
                break;
            }
            case "refinance":
                if (this.app().selection.selectedloan.hash !== "") {
                    loansize = this.app().selection.loansize
                    downpayment = defdownpayment = com.safeParseInt(this.app().loanbalance) - loansize;
                } else {
                    downpayment = defdownpayment = com.safeParseInt(this.app().selection.paydown);
                    loansize = com.safeParseInt(this.app().loanbalance) - downpayment;
                }
                if (downpayment < 0 || downpayment > com.safeParseInt(this.app().loanbalance)) {
                    const balance = com.safeParseInt(this.app().loanbalance)
                    downpayment = defdownpayment = Math.max(0, Math.min(downpayment, balance))
                    loansize = Math.max(0, balance - downpayment)
                }
                this.persistSelectField(downpayment, "paydown");
                break;
            case "cashoutrefinance":
                if (this.app().selection.selectedloan.hash !== "") {
                    loansize = this.app().selection.loansize
                    downpayment = defdownpayment = loansize - com.safeParseInt(this.app().loanbalance);
                    if (downpayment <= 0) {
                        downpayment = defdownpayment = 30000;
                    }
                } else {
                    downpayment = defdownpayment = com.safeParseInt(this.app().selection.cashout);
                    loansize = com.safeParseInt(this.app().loanbalance) + downpayment;
                }
                this.persistSelectField(downpayment, "cashout");
                break;
            default:
                break;
        }

        // 合并到 newState
        Object.assign(newState, { downpayment, defdownpayment, loansize });

        // 最后 setState
        this.setState(newState);
    }
    getLoanSize = () => {
        const { propertyvalue, currentbalance, defdownpayment } = this.state;
        const { purpose } = this.app().property;
    
        if (purpose === "purchase") {
            // 购房：loansize = propertyvalue - defdownpayment
            return Number(propertyvalue) - Number(defdownpayment);
        } else if (purpose === "refinance") {
            // 重贷：loansize = currentbalance - defdownpayment
            return Number(currentbalance) - Number(defdownpayment);
        } else if (purpose === "cashoutrefinance") {
            // 套现重贷：loansize = currentbalance + defdownpayment
            return Number(currentbalance) + Number(defdownpayment);
        }
        return 0;
    }
    seeRates = () => {
        this.clearSelected()

        const searchParams = {
            propertyvalue: this.state.propertyvalue,
            loansize: this.getLoanSize(),
            defdownpayment: this.state.defdownpayment,
        }
        this.setState({
            errorText: '',
            searchParams: searchParams
        })
        this.getDTI(undefined, this.state.fico)
    }
    getLoanLimits = () => {
        fetch("/data/loanlimits")
            .then((res) => {
                if (!res.ok) {
                    throw Error(res.statusText)
                }
                return res.json()
            })
            .then((res) => {
                this.setState({ loanLimits: res })
            })
            .catch((err) => {
                console.error(err)
            })
    }
    getCountyOptions = (st) => {
        let options = []
        options.push({value:"", label:"-"})
        let s = st.toUpperCase()
        if (st.length === 2) {
            s = com.convertAbbStateToFull(st).toUpperCase()
        }

        if (s in this.state.loanLimits) {
            let keys = Object.keys(this.state.loanLimits[s])

            keys.forEach((x) => {
                options.push({ value: com.capitalize(x), label: com.capitalize(x) })
            })
        }
        return options
    };

    getStateOptions = () => {
        let options = []
        options.push({value:"",label:"-"})
        let keys = Object.keys(this.state.loanLimits)

        keys.forEach((x) => {
            options.push({
                value: com.capitalize(x),
                label: com.capitalize(x),
            })
        })
        return options
    }
    isSeeRatesDisabled = () => {
        const {
            propertyvalue,
            propertystate,
            propertycounty,
            fico,
            targetprice, 
            defdownpayment,
            income,
            liabilities,
            currentbalance
        } = this.state;
    
        const { purpose } = this.app().property;

        let defdownpaymentFilled;
        if (purpose === 'refinance' || purpose === 'cashoutrefinance') {
            defdownpaymentFilled = (
                defdownpayment !== null &&
                defdownpayment !== undefined &&
                defdownpayment !== '' &&
                Number(defdownpayment) >= 0
            ); // allow 0, disallow negative
        } else {
            defdownpaymentFilled = Number(defdownpayment) > 0; // must be > 0
        }

        let liabilitiesFilled =
            liabilities !== null &&
            liabilities !== undefined &&
            liabilities !== '' &&
            Number(liabilities) >= 0;

        let allFilled =
            fico &&
            propertyvalue &&
            propertystate &&
            propertycounty &&
            targetprice &&
            defdownpaymentFilled &&
            income &&
            liabilitiesFilled;
    
        // refinance 或 cashoutrefinance 时校验 currentbalance
        if (purpose === 'refinance' || purpose === 'cashoutrefinance') {
            allFilled = allFilled && currentbalance;
        }
    
        return !allFilled || this.amountOutOfRange();
    }
    warningIcon = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <rect width="18" height="18" rx="9" fill="#CB8600"/>
                <rect x="8" y="4" width="2" height="7" rx="1" fill="white"/>
                <rect x="10" y="12" width="2" height="2" rx="1" transform="rotate(90 10 12)" fill="white"/>
            </svg>
        )
    }
    selectIcon = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M22.3292 14.6544L21.2686 13.5938L16.673 18.1893L12.0792 13.5956L11.0186 14.6562L15.6123 19.25L15.6117 19.2506L16.6724 20.3113L16.673 20.3107L16.6754 20.3131L17.7361 19.2524L17.7336 19.25L22.3292 14.6544Z" fill="#6E6E70"/>
            </svg>
        )
    }
    // Cash-out beyond the equity (value - balance). Flagged rather than capped with `max`:
    // a cap tied to another field rejects every keystroke while that field is still being typed.
    cashoutOverLimit = () => {
        const limit = com.safeParseInt(this.state.propertyvalue) - com.safeParseInt(this.state.currentbalance)
        return limit > 0 && Number(this.state.defdownpayment) > limit
    }
    // Down payment >= value, paydown > balance or cash-out > equity: no valid loan amount to price.
    amountOutOfRange = () => {
        const purpose = this.app().property.purpose
        const amount = Number(this.state.defdownpayment)
        if (purpose === 'refinance') return amount > Number(this.state.currentbalance)
        if (purpose === 'cashoutrefinance') return this.cashoutOverLimit()
        return amount >= Number(this.state.propertyvalue)
    }
    // Down payment / paydown / cash-out field: empty, or outside what the value or balance allows.
    amountWarning = () => {
        const purchase = !['refinance', 'cashoutrefinance'].includes(this.app().property.purpose)
        return this.isWarning(this.state.defdownpayment, !purchase) || this.amountOutOfRange()
    }
    isWarning = (value, allowZero = false) => {
        if (Array.isArray(value) && value.length === 0) {
            return true;
        }
        if (allowZero) {
            return value < 0 || value === null || value === undefined || value === "";
        }
        return value <= 0 || value === null || value === undefined || value === "";
    }
    printDownpayment = () => {

        let filterAmortization = () => {
            return (
              <FilterItem title="Amortization">
                <Select
                  multiple
                  mode="multiple"
                  className="all-rates-select"
                  style={{ width: "100%" }}
                  status={this.isWarning(this.state.typeselected) ? 'warning' : ''}
                  suffixIcon={this.isWarning(this.state.typeselected) ? this.warningIcon() : this.selectIcon()}
                  maxTagCount={1}
                  maxTagPlaceholder={() => this.state.typeselected.length > 1 ? '+' + (this.state.typeselected.length - 1) : ''}
                  maxTagTextLength={8} // 可选：限制标签文本长度
                  // onChange={this.onSelectAmortization}
                  onDeselect={this.onDeselectAmortization}
                  onSelect={this.onSelectAmortization}
                  value={this.state.typeselected}
                  options={[
                    { value: 'all', label: 'All'}, ...typeoptions, 
                  ]}
                />
              </FilterItem>
            );
          };
        let filterIncome = () => {
            return (
                <FilterItem title="Income">
                    <InputNumber
                        size="middle"
                        style={{width: '100%'}}
                        className="all-rates-input"
                        min={0}
                        controls={false}
                        status={this.isWarning(this.state.income) ? 'warning' : ''}
                        suffix={warningSuffix(this.isWarning(this.state.income), this.warningIcon())}
                        // max={com.safeParseInt(this.app().property.salesprice)}
                        prefix="$"
                        formatter={formatDollars}
                        parser={parseDollars}
                        value={this.state.income}
                        onChange={this.changeIncome}
                    />
                </FilterItem>
            )
        }
        let filterLiability = () => {
            return (
                <div className='rate-filter-item'>
                    <FilterItem title="Liabilities">
                        <InputNumber
                            size="middle"
                            style={{width: '100%'}}
                            className="all-rates-input"
                            min={0}
                            controls={false}
                            status={this.isWarning(this.state.liabilities, true) ? 'warning' : ''}
                            suffix={warningSuffix(this.isWarning(this.state.liabilities, true), this.warningIcon())}
                            // max={com.safeParseInt(this.app().property.salesprice)}
                            prefix="$"
                            formatter={formatDollars}
                            parser={parseDollars}
                            value={this.state.liabilities}
                            onChange={this.changeLiabilities}
                        />
                    </FilterItem>
                    <LiabilitiesHint breakdown={this.liabilitiesBreakdown()} shown={this.state.liabilities} />
                </div>
            )
        }
        let filterFirstTimeHomeBuyer = () => {
            return (
                <div style={{height: 48, display: 'flex', alignItems: 'center'}}>
                    <Checkbox
                        className='first-time-home-buyer-checkbox'
                        checked={this.state.firstTimeHomeBuyer}
                        onChange={(e) => {
                            this.setState({firstTimeHomeBuyer: e.target.checked, isEditFilter: true})
                        }}
                    >
                        First time home buyer?
                    </Checkbox>
                </div>
            );
        }

        let filterLoanTerms = () => {
            return (
              <FilterItem title="Loan terms">
                <Select
                  multiple
                  mode="multiple"
                  className="all-rates-select"
                  style={{ width: "100%" }}
                  status={this.isWarning(this.state.termselected) ? 'warning' : ''}
                  suffixIcon={this.isWarning(this.state.termselected) ? this.warningIcon() : this.selectIcon()}
                  maxTagCount={1}
                  maxTagPlaceholder={() => this.state.termselected.length > 1 ? '+' + (this.state.termselected.length - 1) : ''}
                  maxTagTextLength={8} // 可选：限制标签文本长度
                  onSelect={this.onSelectTermsWithAll}
                  onDeselect={this.onDeselectTermsWithAll}
                  value={this.state.termselected}
                  options={[
                    { value: 'all', label: 'All'}, ...this.getTermOptions() 
                  ]}
                />
              </FilterItem>
            );
          };
        let filterLenders = () => {
            return (
              <FilterItem title="Lenders">
                <Select
                  multiple
                  mode="multiple"
                  className="all-rates-select"
                  style={{ width: "100%" }}
                  status={this.isWarning(this.state.selectedlenders) ? 'warning' : ''}
                  suffixIcon={this.isWarning(this.state.selectedlenders) ? this.warningIcon() : this.selectIcon()}
                  maxTagCount={1}
                  maxTagPlaceholder={() => this.state.selectedlenders.length > 1 ? '+' + (this.state.selectedlenders.length - 1) : ''}
                  maxTagTextLength={6} // 可选：限制标签文本长度
                  // onChange={this.onSelectLenders}
                  onSelect={this.onSelectLendersWithAll}
                  onDeselect={this.onDeselectLendersWithAll}
                  value={this.state.selectedlenders}
                  options={[
                    { value: 'all', label: 'All'}, ...this.state.lenders.map((x) => {
                      return { value: x, label: com.formatLenderDisplayName(x) };
                    })
                  ]}
                />
              </FilterItem>
            );
          };
        let filterPropertyType = () => {
            return (
            <FilterItem title="Property type">
                <Select
                    className='all-rates-select'
                    style={{width:"100%"}}
                    value={this.state.propertytype}
                    status={this.isWarning(this.state.propertytype) ? 'warning' : ''}
                    suffixIcon={this.isWarning(this.state.propertytype) ? this.warningIcon() : this.selectIcon()}
                    onChange={(value) => {
                        this.setState({propertytype: value, isEditFilter: true}); 
                        if (value === 'manufacturedhome') {
                            // Remove '30' from termselected if it exists
                            const newTerms = this.state.termselected.filter(term => term !== 30);
                            if (newTerms.length !== this.state.termselected.length) {
                                this.setState({termselected: newTerms});
                                this.onSelectTerms(newTerms);
                            }
                        }
                    }}
                    options={[
                        {value: "singlefamilydetached", label: "Single Family Home, Detached"},
                        {value: "singlefamilyattached", label: "Single Family Home, Attached"},
                        {value: "condominiumdetached", label: "Condominium, Detached"},
                        {value: "condominium", label: "Condominium, Attached"},
                        {value: "pudattached", label: "Planned Unit Development, attached"},
                        {value: "puddetached", label: "Planned Unit Development, detached"},
                        {value: "twotofourfamily", label: "2 to 4 Unit Multifamily"},
                        {value: "commercial", label: "5+ Unit Multifamily (not priced)"},
                        {value: "manufacturedhome", label: "Manufactured Home"}
                    ]}
                />
            </FilterItem>
            )
        }

        let filterMtypes = () => {
            if (this.app().product.mortgageapplied === "nonqm") {
              return (
                <FilterItem title="Doc types">
                  <Select
                    multiple
                    mode="multiple"
                    className="all-rates-select"
                    style={{ width: "100%" }}
                    status={this.isWarning(this.state.selectedincomedoctypes) ? 'warning' : ''}
                    suffixIcon={this.isWarning(this.state.selectedincomedoctypes) ? this.warningIcon() : this.selectIcon()}
                    maxTagCount={1}
                    maxTagPlaceholder={() => this.state.selectedincomedoctypes.length > 1 ? '+' + (this.state.selectedincomedoctypes.length - 1) : ''}
                    maxTagTextLength={8} // 可选：限制标签文本长度
                    // onChange={this.onSelectIncomeDocTypes}
                    onSelect={this.onSelectIncomeDocTypesWithAll}
                    onDeselect={this.onDeselectIncomeDocTypesWithAll}
                    value={this.state.selectedincomedoctypes}
                    options={[
                      { value: 'all', label: 'All'}, ...this.state.incomedoctypes.map((x) => {
                        return { value: x, label: com.allIncomeTypes[x] || x };
                      })
                    ]}
                  />
                </FilterItem>
              );
            }
      
            return (
              <FilterItem title="Loan types">
                <Select
                  multiple
                  mode="multiple"
                  className="all-rates-select"
                  style={{ width: "100%" }}
                  status={this.isWarning(this.state.selectedmtypes) ? 'warning' : ''}
                  suffixIcon={this.isWarning(this.state.selectedmtypes) ? this.warningIcon() : this.selectIcon()}
                  maxTagCount={1}
                  maxTagPlaceholder={() => this.state.selectedmtypes.length > 1 ? '+' + (this.state.selectedmtypes.length - 1) : ''}
                  maxTagTextLength={6}
                  onSelect={this.onSelectMortgageTypesWithAll}
                  onDeselect={this.onDeselectMortgageTypesWithAll}
                  value={this.state.selectedmtypes}
                  options={[
                    { value: 'all', label: 'All'}, ...this.state.mtypes.map((x) => {
                      return { value: x, label: x };
                    })
                  ]}
                />
              </FilterItem>
            );
        };
        let filterTargetPrice = () => {
            return (
                <FilterItem title="Target point">
                    <InputNumber
                        controls={false}
                        size="middle"
                        className="all-rates-input"
                        suffix="%"
                        value={this.state.targetprice}
                        onChange={this.onSelectTargetPrice}
                    />
                </FilterItem>
            );
        }
        
        let propertyValue = () => {
            let propertyvalue = this.app().property.purpose === "purchase" ? this.app().property.salesprice : this.app().property.appraisal
            let updatePropertyValue = () => {
                this.app().property.purpose === "purchase" ? this.persistPropertyField(this.state.propertyvalue, "salesprice") : this.persistPropertyField(this.state.propertyvalue, "appraisal")

                if (this.app().property.purpose === "purchase") {
                    if (this.state.loansize >= 0) {
                        this.persistSelectField(this.state.loansize, "loansize")
                        this.persistSelectedLoanField(this.state.loansize, "loansize")
                    }
                }
            }
            return (
                <div className='rate-filter-item'>
                    <FilterItem title="Property value">
                        <InputNumber
                            size="middle"
                            style={{width: '100%'}}
                            className="all-rates-input"
                            min={0}
                            controls={false}
                            status={this.isWarning(this.state.propertyvalue) ? 'warning' : ''}
                            suffix={warningSuffix(this.isWarning(this.state.propertyvalue), this.warningIcon())}
                            // max={com.safeParseInt(this.app().property.salesprice)}
                            prefix="$"
                            formatter={formatDollars}
                            parser={parseDollars}
                            value={this.state.propertyvalue}
                            onChange={this.changePropertyValue}
                        />
                    </FilterItem>
                    <div className='rate-filter-item-update'>
                        <div>Current 1003 value:</div>
                        <div><span className='rate-filter-item-update-value'>$ {com.commaizeFloat(propertyvalue)}</span>. <span className='rate-filter-item-update-btn' onClick={updatePropertyValue}>Update</span></div>
                    </div>
                </div>
            )
        }
        let currentBalance = () => {

            let updateCurrentBalance = () => {
                this.persistApplicationAttribute(this.state.currentbalance, 'loanbalance')
                this.persistSelectField(this.state.loansize, "loansize")
                this.persistSelectedLoanField(this.state.loansize, "loansize")

            }
            return (
                <div className='rate-filter-item'>
                    <FilterItem title="Current balance">
                        <InputNumber
                            size="middle"
                            style={{width: '100%'}}
                            className="all-rates-input"
                            min={0}
                            controls={false}
                            status={this.isWarning(this.state.currentbalance) ? 'warning' : ''}
                            suffix={warningSuffix(this.isWarning(this.state.currentbalance), this.warningIcon())}
                            // max={com.safeParseInt(this.app().property.salesprice)}
                            prefix="$"
                            formatter={formatDollars}
                            parser={parseDollars}
                            value={this.state.currentbalance}
                            onChange={this.changeCurrentBalance}
                        />
                    </FilterItem>
                    <div className='rate-filter-item-update'>
                        <div>Current 1003 value:</div>
                        <div><span className='rate-filter-item-update-value'>$ {com.commaizeFloat(this.app().loanbalance)}</span>. <span className='rate-filter-item-update-btn' onClick={updateCurrentBalance}>Update</span></div>
                    </div>
                </div>
            )
        }
        let propertyState = () => {
            return (
                <FilterItem title="Property state">
                    <Select 
                        className='all-rates-select'
                        style={{width:"100%"}}
                        status={this.isWarning(this.state.propertystate) ? 'warning' : ''}
                        suffixIcon={this.isWarning(this.state.propertystate) ? this.warningIcon() : this.selectIcon()}
                        onChange={this.changePropertyState}
                        value={this.state.propertystate}
                        options={this.getStateOptions()}
                    />
                </FilterItem>
            )
        }
        let propertyCounty = () => {
            return (
                <FilterItem title="Property county">
                    <Select 
                        className='all-rates-select'
                        style={{width:"100%"}}
                        status={this.isWarning(this.state.propertycounty) ? 'warning' : ''}
                        suffixIcon={this.isWarning(this.state.propertycounty) ? this.warningIcon() : this.selectIcon()}
                        onChange={this.changePropertyCounty}
                        value={this.state.propertycounty}
                        options={this.getCountyOptions(this.state.propertystate)}
                    />
                </FilterItem>
            )
        }
        
        let estimatedFICO = () => {
            return (
                <FilterItem title="Est. FICO score">
                    <InputNumber
                        size="middle"
                        className="all-rates-input"
                        value={this.state.fico}
                        min={500}
                        max={1000}
                        precision={0}
                        controls={false}
                        status={this.isWarning(this.state.fico) ? 'warning' : ''}
                        suffix={warningSuffix(this.isWarning(this.state.fico), this.warningIcon())}
                        onChange={this.changeFico}
                    />
                </FilterItem>
            );
        }
        let filterActionBar = () => {
            return <div className='rate-filter-action-bar'>
                <div className='reset-to-1003-values' onClick={this.resetTo1003Values}>Reset to 1003 values</div>
                <div className='see-rates-button-wrap'>
                    <img src="/images/rate-filter.svg" alt="See rates" onClick={() => this.setState({ showFilterForm: !this.state.showFilterForm })} />
                    <Button className='see-rates-button' onClick={this.seeRates} disabled={this.isSeeRatesDisabled()}>See rates</Button>
                </div>
            </div>
        }
        let filterForm = () => {
            return <div className='rate-filter-form'>
                <div style={{padding: '30px 8px 0 0'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.4475 4.66343C2.64132 4.25805 3.05072 4 3.50005 4H24.5001C24.9359 4 25.3354 4.24294 25.5359 4.62993C25.7364 5.01691 25.7045 5.48339 25.4532 5.83946L18.6667 15.4536V25C18.6667 25.6443 18.1444 26.1667 17.5001 26.1667C16.8557 26.1667 16.3334 25.6443 16.3334 25V15.0833C16.3334 14.8424 16.408 14.6074 16.5469 14.4105L22.2485 6.33333H5.9402L12.4081 14.3508C12.5754 14.5583 12.6667 14.8168 12.6667 15.0833V22.025C12.6667 22.6693 12.1444 23.1917 11.5001 23.1917C10.8557 23.1917 10.3334 22.6693 10.3334 22.025V15.4953L2.59202 5.89919C2.3099 5.54947 2.25368 5.06881 2.4475 4.66343Z" fill="#6E6E70"/>
                    </svg>
                </div>
                <RowAnt gutter={12} className='rate-filter-form-content'>
                    <ColAnt style={{marginBottom: 12}} span={6}>
                        {filterLoanTerms()}
                    </ColAnt>
                    <ColAnt style={{marginBottom: 12}} span={6}>
                        {filterMtypes()}
                    </ColAnt>
                    <ColAnt style={{marginBottom: 12}} span={6}>
                        {filterAmortization()}
                    </ColAnt>
                    <ColAnt style={{marginBottom: 12}} span={6}>
                        {filterLenders()}
                    </ColAnt>
                    <ColAnt style={{marginBottom: 12}} span={6}>
                        {filterPropertyType()}
                    </ColAnt>
                    <ColAnt style={{marginBottom: 12}} span={6}>
                        {filterFirstTimeHomeBuyer()}
                    </ColAnt>
                </RowAnt>
            </div>
        }
        let get1003Downpayment = () => {
           const purchase = resolvePurchaseAmounts(this.app())
           return purchase.downpayment
        }
        let get1003PaydownPrincipal = () => {
            if (this.app().selection.selectedloan.hash !== "") {
                return com.safeParseInt(this.app().loanbalance) - this.app().selection.loansize
            } else {
                return com.safeParseInt(this.app().selection.paydown)
            }
        }
        let get1003Cashout = () => {
            if (this.app().selection.selectedloan.hash !== "") {
                return this.app().selection.loansize - com.safeParseInt(this.app().loanbalance)
            } else {
                return com.safeParseInt(this.app().selection.cashout)
            }
        }
        let updateDownpayment = () => {
            let dp = this.state.defdownpayment
            let ls = this.state.propertyvalue - parseFloat(dp)
            this.persistSelectFields({
                downpayment: com.safeParseInt(dp),
                loansize: ls.toString(),
            })
        }
        let updatePaydownPrincipal = () => {
            let dp = this.state.defdownpayment
            let ls = com.safeParseInt(this.state.currentbalance) - parseFloat(dp)
            this.persistSelectFields({
                downpayment: com.safeParseInt(dp),
                paydown: com.safeParseInt(dp),
                loansize: ls.toString(),
            })
        }
        let updateCashout = () => {
            let dp = this.state.defdownpayment
            let ls = com.safeParseInt(this.state.currentbalance) + parseFloat(dp)
            this.persistSelectFields({
                loansize: ls.toString(),
                cashout: com.safeParseInt(dp),
            })
        }
        let purchase = () => {
            return <div style={{overflow: 'hidden', position: 'relative'}}>
                {/* <div style={{padding: '0 38px 0 36px'}} className='d-flex align-items-center '>
                    <div  className='title-5'>Purchase Price:</div>
                    <div className='bold ml-1 mr-3'>${com.commaize(this.app().property.salesprice)}</div>
                    <div  className='title-5'>Loan amount:</div>
                    <div className='bold ml-1 mr-3'>${com.commaize(this.app().property.salesprice - this.state.downpayment)}</div>
                    <div  className='title-5'>LTV:</div>
                    <div className='bold ml-1 mr-3'>{getPercent()}%</div>
                </div> */}
                <RowAnt style={{padding: '0 38px 0 36px'}} gutter={12} className='productPickerFiltersWrap' ref={this.filtersWrapRef} onScroll={this.handleScroll}>
                    <ColAnt span={4}>
                        {propertyValue()}
                    </ColAnt>
                    <ColAnt span={4}>
                        <div className='rate-filter-item'>
                            <FilterItem title="Down Payment">
                                <InputNumber
                                    size="middle"
                                    style={{width: '100%'}}
                                    className="all-rates-input"
                                    min={0}
                                    controls={false}
                                    status={this.amountWarning() ? 'warning' : ''}
                                    suffix={warningSuffix(this.amountWarning(), this.warningIcon())}
                                    prefix="$"
                                    formatter={formatDollars}
                                    parser={parseDollars}
                                    value={this.state.defdownpayment}
                                    onChange={this.changeDownpayment}
                                />
                            </FilterItem>
                            <div className='rate-filter-item-update'>
                                <div>Current 1003 value:</div>
                                <div><span className='rate-filter-item-update-value'>$ {com.commaizeFloat(get1003Downpayment())}</span>. <span className='rate-filter-item-update-btn' onClick={updateDownpayment}>Update</span></div>
                            </div>
                        </div>
                    </ColAnt>
                    <ColAnt span={4}>
                        {filterTargetPrice()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {estimatedFICO()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {propertyState()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {propertyCounty()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {filterIncome()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {filterLiability()}
                    </ColAnt>
                    <ColAnt span={16}>
                        {filterActionBar()}
                    </ColAnt>
                </RowAnt>
                {this.state.showFilterForm && filterForm()}
                {this.state.showLeftButton && (
                    <img
                        className="rate-filter-scroll-button left-scroll-button"
                        src="/images/rate-right-scroll.svg"
                        alt="Scroll to Left"
                        onClick={this.scrollToLeft}
                    />
                )}
                {this.state.showRightButton && (
                    <img
                        className="rate-filter-scroll-button right-scroll-button"
                        src="/images/rate-right-scroll.svg"
                        alt="Scroll to Right"
                        onClick={this.scrollToRight}
                    />
                )}
        </div>


        }
        
        let refinance = () => {
            return <div style={{overflow: 'hidden', position: 'relative'}}>
                {/* <div style={{padding: '0 38px 0 36px'}} className='d-flex align-items-center '>
                    <div  className='title-5'>Current balance:</div>
                    <div className='bold ml-1 mr-3'>${com.commaize(this.app().loanbalance)}</div>
                    <div  className='title-5'>Loan amount:</div>
                    <div className='bold ml-1 mr-3'>${com.commaize(com.safeParseInt(this.app().loanbalance) - this.state.downpayment)}</div>
                    <div  className='title-5'>LTV:</div>
                    <div className='bold ml-1 mr-3'>{getPercent()}%</div>
                </div> */}
                <RowAnt style={{padding: '0 38px 0 36px'}} gutter={12} className='productPickerFiltersWrap' ref={this.filtersWrapRef} onScroll={this.handleScroll}>
                    <ColAnt span={4}>
                        {propertyValue()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {currentBalance()}
                    </ColAnt>
                    <ColAnt span={4}>
                        <div className='rate-filter-item'>
                            <FilterItem title="Paydown principal">
                                <InputNumber
                                    style={{width: '100%'}}
                                    className="all-rates-input"
                                    min={0}
                                    controls={false}
                                    status={this.amountWarning() ? 'warning' : ''}
                                    suffix={warningSuffix(this.amountWarning(), this.warningIcon())}
                                    prefix="$"
                                    formatter={formatDollars}
                                    parser={parseDollars}
                                    value={this.state.defdownpayment}
                                    onChange={this.changePaydown}
                                />
                            </FilterItem>
                            <div className='rate-filter-item-update'>
                                <div>Current 1003 value:</div>
                                <div><span className='rate-filter-item-update-value'>$ {com.commaizeFloat(get1003PaydownPrincipal())}</span>. <span className='rate-filter-item-update-btn' onClick={updatePaydownPrincipal}>Update</span></div>
                            </div>
                        </div>
                    </ColAnt>
                    <ColAnt span={4}>
                        {filterTargetPrice()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {estimatedFICO()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {propertyState()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {propertyCounty()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {filterIncome()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {filterLiability()}
                    </ColAnt>
                    <ColAnt span={12}>
                        {filterActionBar()}
                    </ColAnt>
                </RowAnt>
                {this.state.showFilterForm && filterForm()}
                {this.state.showLeftButton && (
                    <img
                        className="rate-filter-scroll-button left-scroll-button"
                        src="/images/rate-right-scroll.svg"
                        alt="Scroll to Left"
                        onClick={this.scrollToLeft}
                    />
                )}
                {this.state.showRightButton && (
                    <img
                        className="rate-filter-scroll-button right-scroll-button"
                        src="/images/rate-right-scroll.svg"
                        alt="Scroll to Right"
                        onClick={this.scrollToRight}
                    />
                )}
            </div>
        }
        
        let cashout = () => {
            return <div style={{overflow: 'hidden', position: 'relative'}}>
                {/* <div style={{padding: '0 38px 0 36px'}} className='d-flex align-items-center '>
                    <div  className='title-5'>Current balance:</div>
                    <div className='bold ml-1 mr-3'>${com.commaize(this.app().loanbalance)}</div>
                    <div  className='title-5'>Loan amount:</div>
                    <div className='bold ml-1 mr-3'>${com.commaize(com.safeParseInt(this.app().loanbalance) + this.state.downpayment)}</div>
                    <div  className='title-5'>LTV:</div>
                    <div className='bold ml-1 mr-3'>{getPercent()}%</div>
                </div> */}
                <RowAnt style={{padding: '0 38px 0 36px'}} gutter={12} className='productPickerFiltersWrap' ref={this.filtersWrapRef} onScroll={this.handleScroll}>
                    <ColAnt span={4}>
                        {propertyValue()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {currentBalance()}
                    </ColAnt>
                    <ColAnt span={4}>
                        <div className='rate-filter-item'>
                            <FilterItem title="Cash out">
                                <InputNumber
                                style={{width: '100%'}}
                                className="all-rates-input"
                                min={0}
                                controls={false}
                                status={this.amountWarning() ? 'warning' : ''}
                                suffix={warningSuffix(this.amountWarning(), this.warningIcon())}
                                prefix="$"
                                formatter={formatDollars}
                                parser={parseDollars}
                                value={this.state.defdownpayment}
                                onChange={this.changeCashout}
                            />
                            </FilterItem>
                            <div className='rate-filter-item-update'>
                                <div>Current 1003 value:</div>
                                <div><span className='rate-filter-item-update-value'>$ {com.commaizeFloat(get1003Cashout())}</span>. <span className='rate-filter-item-update-btn' onClick={updateCashout}>Update</span></div>
                            </div>
                        </div>
                    </ColAnt>
                    <ColAnt span={4}>
                        {filterTargetPrice()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {estimatedFICO()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {propertyState()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {propertyCounty()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {filterIncome()}
                    </ColAnt>
                    <ColAnt span={4}>
                        {filterLiability()}
                    </ColAnt>
                    <ColAnt span={12}>
                        {filterActionBar()}
                    </ColAnt>
                </RowAnt>
                {this.state.showFilterForm && filterForm()}
                {this.state.showLeftButton && (
                    <img
                        className="rate-filter-scroll-button left-scroll-button"
                        src="/images/rate-right-scroll.svg"
                        alt="Scroll to Left"
                        onClick={this.scrollToLeft}
                    />
                )}
                {this.state.showRightButton && (
                    <img
                        className="rate-filter-scroll-button right-scroll-button"
                        src="/images/rate-right-scroll.svg"
                        alt="Scroll to Right"
                        onClick={this.scrollToRight}
                    />
                )}
            </div>
        }

        switch (this.app().property.purpose) {
            case "purchase":
                return purchase()
            case "refinance":
                return refinance()
            case "cashoutrefinance":
                return cashout()
            default:
                // alert("should not see this!")
                return "";
        }
    }
    getClosingCosts = (card) => {

        let cc = card.closing_cost

        if (cc < 0)
            cc = 0
        return cc
    }
    deleteSelection = () => {
        com.touch()
        this.persistSelectField(new ChosenLoan(), "selectedloan")
    }

    displaySelectedCard = (loan) => {
        let getName = (card) => {
            const matchingproductsItem = loan?.matchingproducts?.[0];
            return matchingproductsItem ? `${com.formatLenderDisplayName(matchingproductsItem.Lender)}, ${matchingproductsItem.Name}` : com.capitalize(card.Mtype.replace('_', ' ').toLowerCase().replace('fha', 'FHA'));
        }
        let removeLOSelectedRate = (loan) => {
            let loSelectedLoans = this.app().selection.loSelectedLoans.filter(l => l.hash !== loan.hash)
            this.persistSelectField(loSelectedLoans, "loSelectedLoans")
        }
        return <div className={`${this.isSelectedByBorrower(loan) ? "chosenRateWrap" : ""} loSelectedRateWrap`}>
                <div style={{marginBottom: 12}}>
                    <div className='d-flex  align-items-center justify-content-between'>
                        <div style={{display: 'flex', alignItems: 'center', gap: 10}}><img src='/images/rate-recommended.svg'/><div style={{fontFamily: 'Inter', fontSize: 16, color: '#222', fontWeight: 500, lineHeight: '30px'}}>{getName(loan)}</div></div>
                        <div className='d-flex'>
                            {/* {isSelectedByBorrower(loan) && <>
                                <a ref={this.downloadDTIspreadsheetRef} hidden href={`data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${this.state.DTISpreadsheet}`} download={this.props.borrower.fullname +  " DTI Spreadsheet"} >&nbsp;</a>
                            <Button type='secondary' onClick={this.generateDTISpreadsheet} loading={this.state.dtiSpreadsheetLoading} >DTI Spreadsheet</Button>
                            </>} */}
                            <div className='rate-remove' onClick={()=>removeLOSelectedRate(loan)}>Remove</div>
                        </div>
                    </div>
                </div>
                <div className='rate-info d-flex justify-content-between'>
                    <div>
                        <div className='rate-info-label'>Rate</div>
                        <div className='rate-info-value'>{loan.base_rate}%</div>
                    </div>
                    <div>
                        <div className='rate-info-label'>APR</div>
                        <div className='rate-info-value'>{loan.APR}%</div>
                    </div>
                    <div>
                        <div className='rate-info-label'>Mo. payment</div>
                        <div className='rate-info-value'>${com.commaize(loan.monthly_payment)}</div>
                    </div>
                    <div>
                        <div className='rate-info-label'>Closing cost</div>
                        <div className='rate-info-value'>
                            <div>${com.commaize(loan.closing_cost)}</div>
                            <img
                                src='/images/rate-detailedCard.svg'
                                style={{
                                    cursor: "pointer"
                                }}
                                onClick={() => this.openClosingCostDetails(loan, "selected")}
                            />
                        </div>
                    </div>
                    <div>
                        <div className='rate-info-label'>Point</div>
                        <div className='rate-info-value'>{loan.points}%/${com.commaizeFloat(loan.lender_credit)}</div>
                    </div>
                </div>
        </div>
    }
    isSelectedByBorrower = (loan) => {
        return this.app().selection.selectedloan.hash === loan.hash
    }
    displaySelectedCards = () => {

        if (this.app().selection.loSelectedLoans.length === 0) {
            return <div className='recommendRatesNoRatesTip'>
                <img style={{marginBottom: 10}} src='/images/rate-recommended-nodata.svg' />
                <div>You haven't recommended any rates yet.</div>
                <div>Please select and recommend rates to your borrower from All rates below.</div>
            </div>
        }

        return <div>
            {(this.app().selection.selectedloan.hash !== "") && <div className='recommendRatesNoRatesTip mb-2'>
                <div>Your borrower has selected their preferred recommended rate.</div>
            </div>}
            
            {this.app().selection.loSelectedLoans
                .slice()
                .sort((a, b) => {
                    if (this.isSelectedByBorrower(a) && !this.isSelectedByBorrower(b)) return -1;
                    if (!this.isSelectedByBorrower(a) && this.isSelectedByBorrower(b)) return 1;
                    return 0;
                })
                .map(loan => this.displaySelectedCard(loan))}
        </div>

        if (!isMobileOnly && (this.app().selection.selectedloan === null || this.app().selection.selectedloan.hash === "")) {
            return ""
        }

        let card = this.app().selection.selectedloan
        let currentMonthly = com.getMonthlyValue(this.app().borrower.expenses.currentfirstmortgage,
            this.app().borrower.expenses.currentfirstmortgageperiod)
        let mostyle = {}
        if (card.monthly_payment > parseFloat(currentMonthly)) {
            mostyle = { color: '#c33' }
        } else {
            mostyle = { color: '#393' }
        }
        let showSavings = () => {
            if (this.app().property.purpose !== "refinance")
                return ""
            if (card.monthly_payment > parseFloat(currentMonthly)) {
                return <i className="ml-1 fas fa-arrow-up"></i>
            }
            return <i className="ml-1 fas fa-arrow-down"></i>
        }
        let getName = () => {
            if (this.props.borrowerid && this.referi && this.referi[card.hash] != null) {
                let r = this.referi[card.hash]
                if (r !== undefined && r[0] !== undefined)
                    return com.capitalize(r[0]["Lender"]) + ", " + r[0]["Name"]
            }
            return com.capitalize(card.Mtype.replace('_', ' ').toLowerCase().replace('fha', 'FHA'))
        }
        let getType = (card) => {
            if (null == card)
                return ""
            if (card.Arm == null || card.amortization === "fixed")
                return "Fixed rate"
            return "ARM " + card.Arm.fixedperiod + "/6"
        }
        let loansize = com.safeParseInt(card.loansize)


        let points = com.commaizeFloat((card.points * com.safeParseInt(card.loansize) / 100).toFixed(2))
        let moPayment = () => {

            let payment = card.monthly_payment
            if (card.pmi !== 0) {
                payment = payment + card.pmi
            } else if (card.FHAMIP != null) {
                payment = payment + card.FHAMIP.monthlyMIP
            }
            payment = com.commaizeFloat(payment.toFixed(2))
            return payment
        }

        let getBreakPoint = (loan) => {
            let interestRate = this.getOldInterestRate()

            function getClosedInterestPaid(rate, loansize, termmonths, spanmonths) {

                let monthlyrate = rate / 12.0
                let expn = Math.pow(1 + monthlyrate, termmonths)
                let payment = loansize * monthlyrate * expn / (expn - 1)
                payment = (Math.round(payment * 100) / 100)

                let accumulatedinterest = (loansize * monthlyrate - payment) *
                    (Math.pow(1 + monthlyrate, spanmonths) - 1) / monthlyrate +
                    spanmonths * payment
                return accumulatedinterest
            }

            let breakPoint = -1
            if (parseFloat(interestRate) <= loan.base_rate) {
                return breakPoint
            }

            for (let i = 1; i <= loan.Term * 12; i++) {
                let accumulatedOld = getClosedInterestPaid(parseFloat(interestRate) / 100, loan.loansize, loan.Term * 12, i)
                let accumulatedNew = getClosedInterestPaid(loan.base_rate / 100, loan.loansize, loan.Term * 12, i)

                accumulatedNew += loan.closing_cost
                if (accumulatedNew < accumulatedOld) {
                    breakPoint = i
                    break
                }
            }
            return breakPoint
        }
        let image = this.state.selectedImage
        let onHidePriceChanged = () => {
            this.setState({ showPriceChanged: false })
        }
        let useSuggestion = () => {
            this.persistSelectField(this.state.suggestedLoan, "selectedloan")
            this.getSelectedIcon(this.state.suggestedLoan)
            this.setState({ showPriceChanged: false })
        }

        let oncheckbox = (e) => {
            let ch = e.target.checked
            let ar = this.state.comparisonSelections
            if (ar[card.hash] != null)
                delete ar[card.hash]

            if (ch) {
                ar[card.hash] = this.referi[card.hash]
                ar[card.hash].loansize = card.loansize
                ar[card.hash].paydown = card.paydown
                ar[card.hash].downpayment = card.downpayment
                ar[card.hash].cashout = card.cashout
            }
            this.setState({ comparisonSelections: ar })
        }
        let st = {}
        try {
            if (this.state.suggestedLoan.closing_cost > this.app().selection.selectedloan.closing_cost) {
                st = { color: '#633' }
            } else {
                if (this.state.suggestedLoan.closing_cost < this.app().selection.selectedloan.closing_cost) {
                    st = { color: '#363' }
                }
            }
        } catch (x) {

        }

        return <div className="mb-4" key={card.hash}>
            <div style={{ fontSize: '1.2em', fontWeight: 500 }} className="mb-1 pb-0">Chosen Rate: ${com.commaizeFloat(loansize)}</div>

            <Modal show={this.state.showPriceChanged} onHide={onHidePriceChanged} >
                <Modal.Header closeButton>
                    <Modal.Title className="capitalize">The closing cost of your selected loan has changed!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.suggestedLoan != null ?
                        <div>
                            <Row><Col className="mb-3 sectionquestion text-center">Here's a new suggested loan: </Col> </Row>
                            <Row><Col>Loan type:</Col><Col>{getType(this.state.suggestedLoan)},  {this.state.suggestedLoan.Term} years</Col> </Row>


                            <Row><Col>Loan amount:</Col><Col> ${com.commaizeFloat(this.state.suggestedLoan.loansize)}</Col> </Row>
                            <Row><Col>Base rate: </Col><Col>{this.state.suggestedLoan.base_rate}%</Col> </Row>
                            {this.state.suggestedLoan.base_rate !== this.app().selection.selectedloan.base_rate ?
                                <Row><Col>Old rate: </Col><Col>{this.app().selection.selectedloan.base_rate}% </Col> </Row>
                                : ""
                            }
                            <Row><Col>APR:</Col><Col> {this.state.suggestedLoan.APR}%</Col> </Row>
                            <Row><Col>Monthly payment: </Col><Col>  ${com.commaizeFloat(this.state.suggestedLoan.monthly_payment)}</Col> </Row>
                            {this.state.suggestedLoan.closing_cost >= 0 ?
                                <Row><Col>Closing costs:</Col><Col style={st}>  ${com.commaizeFloat(this.state.suggestedLoan.closing_cost.toFixed(2))}</Col> </Row>
                                :
                                <Row><Col>Closing costs: $0</Col><Col style={st} >Remaining credits: ${com.commaizeFloat(-this.state.suggestedLoan.closing_cost.toFixed(2))}
                                </Col> </Row>
                            }
                            {this.state.suggestedLoan.closing_cost !== this.app().selection.selectedloan.closing_cost ?
                                (this.app().selection.selectedloan.closing_cost >= 0 ?
                                    <Row><Col> Old closing costs:</Col><Col> ${com.commaizeFloat(this.app().selection.selectedloan.closing_cost.toFixed(2))} </Col> </Row> :
                                    <Row><Col>  Old remaining credits:</Col><Col> ${com.commaizeFloat(this.app().selection.selectedloan.closing_cost.toFixed(2))} </Col> </Row>
                                )
                                : ""
                            }

                        </div>
                        : ""
                    }
                </Modal.Body>
                <Modal.Footer className="text-center d-block" >
                    <Row className="text-center">
                        <Col>
                            <Button variant="zeitro-primary" onClick={useSuggestion}>Choose suggestion</Button>
                        </Col>
                        <Col>
                            <Button variant="zeitro-outline" onClick={e => { this.deleteSelection(); onHidePriceChanged() }}>Remove chosen</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>

            <Container key={card.hash} className="loanRates mt-2 w-100 px-0 pb-3 text-left">
                <Row className="bluishbackground text-left  mb-0 mx-0">
                    {/* <Col style={{ paddingRight: '0px', alignItems:"center" }} xs="auto" className="d-flex text-center vertical-middle mx-0 ">
                        {this.state.needsAdjustment ? "" :
                            <Form.Group controlId="emailmethod" className="text-center d-block text-nowrap m-0 p-0" >
                                <Form.Check type="checkbox"
                                    checked={this.state.comparisonSelections[card.hash] != null}
                                    key={card.hash}
                                    disabled={this.state.comparisonSelections[card.hash] == null && Object.keys(this.state.comparisonSelections).length >= 4}
                                    onChange={oncheckbox}
                                    style={{ textAlign: 'center', paddingRight: '0px', paddingLeft: '22px' }}
                                    //className="p-0 m-0"
                                    label=""
                                ></Form.Check>
                            </Form.Group>}
                    </Col> */}
                    <Col className="d-flex text-left  ">
                        <div className="d-flex text-left " style={{ alignItems:"center", fontWeight: 500 }}>
                            {getName()}
                            {this.props.borrowerid ? "" : <div>, &nbsp;{getType(card)}, {card.Term} years</div>}
                        </div>
                    </Col>
                    <Col xs="auto" className="text-right border-bottom loancard p-0 py-1" >
                        <a ref={this.downloadDTIspreadsheetRef} hidden href={`data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${this.state.DTISpreadsheet}`} download={this.props.borrower.fullname +  " DTI Spreadsheet"} >&nbsp;</a>
                        <Button variant='outline' style={{fontSize: 14, minWidth: 136}} onClick={this.generateDTISpreadsheet}>{this.state.dtiSpreadsheetLoading ? <Spinner animation='border' size='sm'/> : "DTI Spreadsheet"}</Button>
                        {this.state.needsAdjustment ?
                            <Button onClick={this.onPriceChange} size="sm" variant="link" style={{ marginTop: '0px', marginBottom: '0px', paddingTop: '0px', paddingBottom: '0px' }}>Click to update the loan</Button>
                            :
                            <Button onClick={this.deleteSelection} size="sm" variant="link">Remove choice</Button>
                        }
                    </Col>
                </Row>
                <Row className="text-left mt-0 mb-0 mx-0">

                    <Col xs={3} className="loancard pt-2 ">
                        <div>Rate / APR</div>
                        <b>{card.base_rate}% / {card.APR}%</b>
                    </Col>
                    <Col xs={3} className=" loancard pt-2 ">
                        <div>Mo. Payment</div>
                        {this.app().property.purpose === "refinance" ? MonhtlyChangeBP(currentMonthly, card.monthly_payment, getBreakPoint(card),
                            <span style={mostyle} ><b>${moPayment()}</b>{showSavings()}</span>
                        ) : <b>${moPayment()}</b>}
                    </Col>
                    <Col xs={3} className=" loancard pt-2 ">
                        <div>Closing Cost</div>
                        <b>${com.commaizeFloat((this.getClosingCosts(card)).toFixed(2))}</b>
                    </Col>
                    <Col xs={3} className=" loancard pt-2 ">
                        <div>Points</div>
                        {com.commaizeFloat(card.points.toFixed(3))}%{card.points <= 0 ? "" : <span>/${points}</span>}
                    </Col>
                </Row>
                <Row className="text-left text-wrap mt-2 mb-0 mx-0 ">
                    <Col className=" d-flow loancard" style={{ color: "#6E6E70" }}>
                        {card.pmi !== 0 ? <span className="mr-3">Requires mortgage insurance ${com.commaizeFloat(card.pmi)}/mo</span> : ""}

                        {com.safeParseInt(card.min_months_reserves) > 0 ?
                            <span className=" py-2  mr-3">
                                Reserves required: {card.min_months_reserves} months
                            </span> : ""}

                        {card.FHAMIP != null ?
                            <span className=" py-2  mr-3">
                                Upfront mortgage insurance premium: ${card.FHAMIP.upfrontMIP}, monthly insurance payment: ${com.commaizeFloat(card.FHAMIP.monthlyMIP)}
                            </span>
                            : ""}
                    </Col>

                </Row>
            </Container>

        </div>

    }

    displayFilters = () => {
        
    return <div>
        <div >
            {this.printDownpayment()}
        </div>

        {/* {this.state.maxreserves > 0 ?
            <div>
                <Row className="mt-2 mb-1"  ><Col style={{ fontWeight: 'bold', fontSize: '1.1em' }}>Limit reserves:</Col><Col>

                    <div className="downpayment" style={{ fontSize: '0.9em', width: '110px !important' }} >

                        <div style={{ paddingTop: '3px', width: '110px !important' }} type="text" size="10"
                        >
                            {this.state.selectedmaxreserves} mo.</div>


                    </div>

                </Col></Row>
                <Row>
                    <Col><HorizontalSlider onUpdate={this.updateReserves} onChange={this.changeReserves} step={1} domain={[0, this.state.maxreserves]} values={[this.state.selectedmaxreserves]} width="240px" style={{ width: "240px" }} /></Col>
                </Row>
            </div> : ""} */}

    </div>

    }

    displayRates = () => {
        let getName = (card) => {
            if ( this.referi && this.referi[card.hash] != null) {
                let r = this.referi[card.hash][0]
                return <div>
                    <div>{com.formatLenderDisplayName(r["Lender"])}</div>
                    <div style={{fontWeight: 400}}>{r["Name"]}</div>
                </div>
            }
            return com.capitalize(card.Mtype.replace('_', ' ').toLowerCase().replace('fha', 'FHA'))
        }
        let handleSelectRate = (card) => {
            if (this.state.ratesToBeRecommended.some(x => x.hash === card.hash)) {
                const updatedRates = this.state.ratesToBeRecommended.filter(x => x.hash !== card.hash);
                this.setState({ ratesToBeRecommended: updatedRates });
            } else {
                this.setState(prevState => ({
                    ratesToBeRecommended: [...prevState.ratesToBeRecommended, card]
                }));
            }
        };
        let displayErrors = () => {
            return <div className='p-3'>{this.state.errorText}</div>
        }
        
        const columns = [
            {
                title: 'Program',
                dataIndex: 'program',
                render: (text, record) => {
                    return getName(record)
                }
              },
              {
                title: 'Rate',
                dataIndex: 'rate',
                render: (text, record) => <div style={{fontWeight: 600}}>{record.base_rate}%</div>,
                sorter: (a, b) => a.base_rate - b.base_rate,
                // defaultSortOrder: "ascend",
                // sortDirections: ["descend", "ascend", "descend"],
                sortOrder: this.state.sortColumn === 'rate' ? this.state.sortOrder : null,
              },
              {
                title: 'APR',
                dataIndex: 'apr',
                render: (text, record) => <div style={{fontWeight: 600}}>{record.APR}%</div>,
                sorter: (a, b) => a.APR - b.APR,
                sortOrder: this.state.sortColumn === 'apr' ? this.state.sortOrder : null,
              },
              {
                title: 'Mo. Payment',
                dataIndex: 'monthlypayment',
                render: (text, record) => <div>${com.commaize(record.monthly_payment)}</div>,
                sorter: (a, b) => a.monthly_payment - b.monthly_payment,
                sortOrder: this.state.sortColumn === 'monthlypayment' ? this.state.sortOrder : null,
              },
              {
                title: 'Points',
                dataIndex: 'points',
                render: (text, record) => <div>{record.points + "%/$" + record.lender_credit }</div>,
                sorter: (a, b) => a.points - b.points,
                sortOrder: this.state.sortColumn === 'points' ? this.state.sortOrder : null,
              },
              {
                title: 'Closing cost',
                dataIndex: 'closingCost',
                render: (text, record) => <div style={{gap: 4}} className='d-flex align-items-center'>
                    <div>
                        {record.closing_cost < 0
                            ? `$-${com.commaize(Math.abs(record.closing_cost))}`
                            : `$${com.commaize(Math.abs(record.closing_cost))}`
                        }
                    </div>
                    <img
                        src='/images/rate-detailedCard.svg'
                        style={{
                            cursor: "pointer"
                        }}
                        onClick={() => this.openClosingCostDetails(record, "all")}
                    />
                </div>,
                sorter: (a, b) => a.closing_cost - b.closing_cost,
                sortOrder: this.state.sortColumn === 'closingCost' ? this.state.sortOrder : null,
              },
              {
                title: '',
                dataIndex: 'add',
                width: 116,
                fixed: 'right',
                render: (text, record) => <div style={{gap: 20}} className='d-flex align-items-center'>
                    <Button className={`${this.state.ratesToBeRecommended.some(x => x.hash === record.hash) ? 'rate-selected-btn' : ""} rate-normal-btn`} onClick={()=>handleSelectRate(record)}>{this.state.ratesToBeRecommended.some(x => x.hash === record.hash) ? 'Selected' : 'Select'}</Button>
                    {/* <Button className={`${this.state.ratesToBeRecommended.some(x => x.hash === record.hash) ? 'rate-selected-btn' : ""} rate-normal-btn`} onClick={()=>handleSelectRate(record)}>{this.state.ratesToBeRecommended.some(x => x.hash === record.hash) ? 'Selected' : 'Select'}</Button> */}
                </div>,
              },
        ]
        return <div style={{padding: '0 38px 0 36px'}}>
            {/* {this.state.loading && <div className='p-2 mt-2'><Skeleton active/><Skeleton active/><Skeleton active/></div>}
            {this.state.products.length === 0 && !this.state.loading && displayErrors()} */}
            <Table 
                className='rates-recommended-table'
                loading={this.state.loading}
                columns={columns} 
                dataSource={this.state.products} 
                showSorterTooltip={false}
                // Scroll sideways on narrow windows so the Select column is never cut off.
                scroll={{ x: 'max-content' }}
                onChange={(pagination, filters, sorter) => {
                    this.setState({
                        sortOrder: sorter.order,
                        sortColumn: sorter.field
                    });
                }}
                locale={{
                    emptyText: <div className='rates-recommended-table-empty text-center'>
                        <div className='empty-data-icon'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="59" height="58" viewBox="0 0 59 58" fill="none">
                                <rect y="3.0127" width="33.1262" height="37.6434" rx="2" fill="#C3CDEA"/>
                                <rect y="3.0127" width="33.1262" height="37.6434" rx="2" fill="#DFE0E8"/>
                                <rect x="13.5522" y="12.0469" width="33.1262" height="33.1262" rx="11" fill="#A4B7F8"/>
                                <rect x="4.51807" y="9.03516" width="24.0918" height="3.01147" rx="1.50573" fill="white"/>
                                <rect x="4.51807" y="16.5635" width="24.0918" height="3.01147" rx="1.50573" fill="white"/>
                                <path d="M15.0581 19.0576C15.0581 16.8485 16.849 15.0576 19.0581 15.0576H33.1269C34.7901 15.0576 36.1384 16.4059 36.1384 18.0691C36.1384 19.7323 34.7901 21.0806 33.1269 21.0806H15.0581V19.0576Z" fill="white"/>
                                <rect x="4.51807" y="24.0928" width="9.03441" height="3.01147" rx="1.50573" fill="white"/>
                                <rect x="10.54" y="25.5986" width="25.5975" height="6.02294" rx="3.01147" fill="white"/>
                                <rect x="13.7212" y="36.3613" width="22.6397" height="6.17446" rx="3.08723" fill="white"/>
                                <rect x="4.51807" y="31.6211" width="9.03441" height="3.01147" rx="1.50573" fill="white"/>
                                <path d="M15.8779 14.3746C23.8161 6.43629 36.6871 6.43573 44.6255 14.3739C52.5638 22.3122 52.5638 35.1839 44.6255 43.1222C36.6871 51.0604 23.8161 51.0598 15.8779 43.1215C7.93976 35.1832 7.93976 22.3129 15.8779 14.3746ZM18.8506 17.3487C12.5548 23.6447 12.5554 33.8522 18.8513 40.1481C25.1472 46.4439 35.3547 46.4445 41.6507 40.1488C47.9466 33.8528 47.9466 23.6446 41.6507 17.3487C35.3547 11.0528 25.1465 11.0528 18.8506 17.3487Z" fill="#525F9D"/>
                                <rect x="41.3613" y="43.0459" width="4.5172" height="12.0459" rx="2.2586" transform="rotate(-45 41.3613 43.0459)" fill="#525F9D"/>
                            </svg>
                        </div>
                        {this.state.products.length === 0 && !this.state.loading && this.state.errorText ? displayErrors() : <div className='empty-data-title'>Please ensure all required fields are filled out.</div>}
                    </div>
                }}
            />
        </div>
    }

    checkStatus = () => {
        let token = sessionStorage.getItem("ZeitroA")
        if ((this.app().remotecoborrowers || []).length > 0) {
            this.setState({ statusloaded: false })
            fetch('/data/coborrowerstatus', {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache",
                    "X-Borrower": this.props.borrowerid,
                }
            }).then(
                response => {
                    if (response.status !== 200) {
                        //alert('Looks like there was a problem. Status Code: ' +
                        //    response.status);
                        //window.document.dispatchEvent(new Event('reauthenticate'), "");

                        return;
                    }
                    // Examine the text in the response
                    response.json().then(js => {
                        let positionbyemail = {}
                        let proc = (a, i) => {
                            let email = a.Email
                            let position = a.Position
                            positionbyemail[email] = position
                        }
                        js.map(proc)
                        this.setState({ positionbyemail: positionbyemail, statusloaded: true })
                    });
                }
            ).catch((err) => {
                alert('Fetch Error :', err);
            });

        }
    }

    renderRemoteCoborrowers = (rb, i) => {
        let getStatus = () => {
            let status = "Invited"
            if (rb.email in this.state.positionbyemail) {
                let pos = this.state.positionbyemail[rb.email]

                status = com.positionToStatus(pos)
            }
            return status
        }
        if (this.state.positionbyemail[rb.email] >= com.prefillLimit)
            return <div></div>
        else {
            clearTimeout(this.timer)
            this.timer = setTimeout(this.checkStatus, 30000)
            return (
                <div className="viewport mb-3 drop-shadow text-left" key={rb.key}>
                    <Form.Row>
                        <Col  >
                            <Form.Group controlId={"first_name" + rb.key} className="text-left" >
                                <Form.Label className="text-left" >First Name:</Form.Label><br />
                                <div style={{ fontSize: '1.2em' }}>{rb.firstname}</div>
                            </Form.Group>
                        </Col>
                        <Col  >
                            <Form.Group controlId={"last_name" + rb.key} className="text-left" >
                                <Form.Label className="text-left" >Last Name:</Form.Label><br />
                                <div style={{ fontSize: '1.2em' }}>{rb.lastname}</div>
                            </Form.Group>
                        </Col>
                        <Col  >
                            <Form.Group controlId={"email" + rb.key} className="text-left" >
                                <Form.Label className="text-left" >Email:</Form.Label><br />
                                <div style={{ fontSize: '1.2em' }}>{rb.email}</div>
                            </Form.Group>
                        </Col>
                        <Col  >
                            <Form.Group controlId={"email" + rb.key} className="text-left" >
                                <Form.Label className="text-left" >Status:</Form.Label><br />
                                <div style={{ fontSize: '1.2em' }}>{getStatus()}</div>
                            </Form.Group>
                        </Col>

                    </Form.Row>
                </div>
            )
        }
    }

    waiting = (num) => {

        return (
            <div className="mx-2 px-2 text-left  mb-4 bg-">
                <h2 className=" heading">
                    Product selector
                </h2>
                <div className="viewport text-center mt-4 ">
                    <div className="mb-3 sectionquestion">{
                        (num === 1) ? <div>Look like your coborrower has not filled enough of their application to allow product selection:</div>
                            : <div>Look like some of your coborrowers have not filled enough of their application to allow product selection:</div>
                    }</div>
                    {this.app().remotecoborrowers.map(this.renderRemoteCoborrowers)}

                </div>
            </div>
        )
    }
    generateDTISpreadsheet = () => {
        this.setState({ dtiSpreadsheetLoading: true }, () => {
            setTimeout(() => {
                // wait for 5 seconds for updating selected loan state
                let token = sessionStorage.getItem("ZeitroA")
                fetch("/los/generatedtispreadsheet", {
                    cache: 'no-cache',
                    method: 'POST',
                    body: JSON.stringify({ CustomerID: this.props.borrower.id, LoanID: this.props.borrower.loan_id }),
                    headers: {
                        Authorization: "Bearer " + token,
                        Cache: "no-cache"
                    },
                }).then(response => {
                    if (response.status !== 200) {
                        this.setState({ dtiSpreadsheetLoading: false })
                        alert("Something went wrong, please try later.")
                        try {
        
                            response.text().then(js => {
                                
                            })
                            return;
                        } catch {
                            return;
                        }
                    }
                    response.json().then((js) => {
                        if (js.RedirectURL !== "Something is wrong") {
                            this.setState({ DTISpreadsheet: js.SpreadsheetB64 }, () => this.downloadDTIspreadsheetRef.current.click());
                        } else {
                            alert("Something went wrong, please try later.")
                        }
                        this.setState({ dtiSpreadsheetLoading: false })
                    })
                })
              }, 5 * 1000)


        })
    }
    showCompareModal = () => {
        if (this.state.ratesToBeRecommended.length > 0) {
            this.setState({ compareModal: true })
        }
    }
    clearSelected = () => {
        this.setState({ ratesToBeRecommended: [] })
    }
    compareModalCancel = () => {
        this.setState({ compareModal: false })
    }
    compareData = () => {
        return this.state.ratesToBeRecommended.map(data => {
            return {
                ...data,
                key: data.hash,
                Lender: this.referi && this.referi[data.hash] != null ? this.referi[data.hash][0]["Lender"] : '',
                Name: this.referi && this.referi[data.hash] != null ? this.referi[data.hash][0]["Name"] : '',
                loanAmount: this.app().property.salesprice - this.state.downpayment,
                rate: data.base_rate,
            }
        })
    }
    showModal = () => {
        this.setState({isModalOpen: true})
    }
    handleOk = () => {
        this.setState({isModalOpen: false})
    }
    handleCancel = () => {
        this.setState({isModalOpen: false})
    }
    cancelSelect = (key) => {
        this.setState((prevState) => ({
            ratesToBeRecommended: prevState.ratesToBeRecommended.filter(item => item.hash !== key)
        }))
    }
    exportPDF = () => {
        this.setState({ isExporting: true });
        
        import('jspdf').then(({ default: jsPDF }) => {
            import('html2canvas').then(({ default: html2canvas }) => {
                const pdf = new jsPDF('p', 'mm', 'a4');
                const detailsComponent = document.querySelector('.loandetails .modal-body');
                
                if (!detailsComponent) {
                    console.error('Could not find Details component');
                    this.setState({ isExporting: false });
                    return;
                }
                
                const tabLinks = detailsComponent.parentElement.querySelectorAll('.nav-link');
                
                // Always switch to Closing Cost Details tab first
                tabLinks[0].click();
                
                // Wait a bit for the first tab to render
                setTimeout(() => {
                    const closingCostDetails = detailsComponent.querySelector('.tab-pane.active');
                    
                    html2canvas(closingCostDetails).then(canvas => {
                        const imgData = canvas.toDataURL('image/png');
                        const imgWidth = 210; // A4 width in mm
                        const imgHeight = canvas.height * imgWidth / canvas.width;

                        // Add "Closing Cost Details" title for the first page
                        pdf.setFontSize(18);
                        pdf.setFont(undefined, 'bold');
                        pdf.text('Closing Cost Details', 105, 20, { align: 'center' });
                        
                        pdf.addImage(imgData, 'PNG', 0, 30, imgWidth, imgHeight);
                        
                        // Second page - Overview Page
                        pdf.addPage();
                        
                        // Add "Loan Overview" title
                        pdf.setFontSize(18);
                        pdf.setFont(undefined, 'bold');
                        pdf.text('Loan Overview', 105, 20, { align: 'center' });
                        
                        // Switch to Overview tab
                        tabLinks[1].click();
                        
                        setTimeout(() => {
                            const overviewTab = detailsComponent.querySelector('.tab-pane.active');
                            
                            html2canvas(overviewTab).then(canvas2 => {
                                const imgData2 = canvas2.toDataURL('image/png');
                                const imgHeight2 = canvas2.height * imgWidth / canvas2.width;
                                
                                pdf.addImage(imgData2, 'PNG', 0, 30, imgWidth, imgHeight2);
                                
                                // Save the PDF
                                pdf.save('Estimated Fee Sheet.pdf');
                                this.setState({ isExporting: false });
                            }).catch(err => {
                                console.error('Error generating PDF:', err);
                                this.setState({ isExporting: false });
                            });
                        }, 300);
                    }).catch(err => {
                        console.error('Error generating PDF:', err);
                        this.setState({ isExporting: false });
                    });
                }, 300);
            }).catch(err => {
                console.error('Error importing html2canvas:', err);
                this.setState({ isExporting: false });
            });
        }).catch(err => {
            console.error('Error importing jsPDF:', err);
            this.setState({ isExporting: false });
        });
    }

    render = () => {


        if (this.app().hascoborrower === "multiple") {
            if (!this.state.statusloaded) {
                return <div className="mb-5 pb-3">
                    <Row><Col className="text-center mt-5 pt-5"><img alt="" className="rotate" src="/logo.svg"></img></Col></Row>

                </div>
            }

            let notready = 0
            let remotes = this.app().remotecoborrowers

            for (let i = 0; i < remotes.length; i++) {
                let pos = this.state.positionbyemail[remotes[i].email]
                if (pos < com.prefillLimit)
                    notready += 1
            }
            if (notready > 0) {
                return <div>
                    {this.waiting(notready)}
                </div>
            }
        }
        return (
            <Container style={{padding: "24px 0"}} id="picker" className="text-center mt-0 mb-2 w-100 px-0 mx-0" fluid>
               
               <Modal show={this.state.show} dialogClassName="loandetails mt-5"
                    onHide={() => this.setState({ show: false })}>
                    <Modal.Header closeButton >
                        <Modal.Title className="d-flex justify-content-between w-100" >
                            <div style={{fontSize: 24, fontWeight: 'bold', color: 'white', fontFamily: 'Inter'}}>Estimated Fee Sheet</div>
                            <div className="d-flex align-items-center"><Button variant="secondary" onClick={this.exportPDF} className="mr-auto"> {this.state.isExporting ? <Spinner animation='border' size='sm'/> : 'Export'}</Button></div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <DetailsV2 seletion={this.app().selection.selectedloan} detailType={this.state.detailType} card={this.state.detailedCard} closingCostsDetail={this.state.detailType === 'all' ? this.state.closingCostsDetail : null} searchParams={this.state.searchParams} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.setState({ show: false })}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.showComparison} dialogClassName="loandetails mt-5"
                    onHide={() => this.setState({ showComparison: false })}>
                    <Modal.Header closeButton >
                        <Modal.Title><img alt="" src="/jackhammer.png" style={{ width: '32px' }}></img>Loan Comparison</Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <Comparison
                            hide={
                                () => {
                                    this.setState({ showComparison: false })
                                }}
                            calldelete={this.removeSelection.bind(this)}
                            callselect={this.selectLoan.bind(this)}
                            selection={this.state.comparisonSelections} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.setState({ showComparison: false })}>
                            Close
                        </Button>

                    </Modal.Footer>
                </Modal>

                <Mod title="The rates you suggested have been forwarded to the borrower." open={this.state.showRecommendRatesModal} onOk={()=>this.setState({showRecommendRatesModal: false})} onCancel={()=>this.setState({showRecommendRatesModal: false})}>
                    <p>Your borrower will receive a notification about the recommended rates. Once a rate has been selected by your borrower, we will promptly inform you.</p>
                </Mod>

                <Row className="text-left" style={{marginBottom: 20, padding: '0 38px 0 36px'}} >
                    <Col style={{padding: 0}}>
                        <div className='recommend-rates-top'>
                            <div className='recommend-rates-title'>Recommend rates</div>
                            <Tooltip 
                                align={{
                                    offset: [10, 8]
                                }}
                                title='Remind borrower'
                                placement="bottomRight"
                            >
                                <img style={{cursor: 'pointer'}} src='/images/rate-reminder.svg' />
                            </Tooltip>
                        </div>
                        <div>
                            {this.displaySelectedCards()}
                        </div>
                    </Col>
                </Row>
                <Row className="text-left " >
                    <Col style={{padding: 0}}>
                        <div style={{margin: '0 38px 0 36px'}} className='d-flex justify-content-between rate-recommendation-all'>
                            <div className='title-3'>
                                All rates
                            </div>
                            <div className="compare-rates">
                                <div className="rate-select-count"><div className="select-count">{this.state.ratesToBeRecommended.length} selected</div>{this.state.ratesToBeRecommended.length > 0 && <div className="clear-btn" onClick={this.clearSelected}>Clear</div>}</div>
                                <div className="compare-rates-line"></div>
                                <div className={`rate-compare-btn ${this.state.ratesToBeRecommended.length === 0 ? 'compare-disabled' : ''}`} onClick={this.showCompareModal}><img src={`/images/rates-compare${this.state.ratesToBeRecommended.length === 0 ? '-disabled' : ''}.svg`}/>Compare rates</div>
                                <Button className='rate-recommend-btn' disabled={this.state.ratesToBeRecommended.length === 0} type='primary' onClick={()=>this.recommendRates()}>Recommend rates</Button>
                            </div>
                        </div>
                        <div>
                            {this.displayFilters()}
                        </div>
                        <div>
                            {this.displayRates()}
                        </div>
                    </Col>


                </Row>
                <CompareProduct
                    open={this.state.compareModal}
                    tableData={this.compareData()}
                    cancelSelect={this.cancelSelect}
                    onCancel={this.compareModalCancel}
                >
                </CompareProduct>
                <Mod title="" open={this.state.isModalOpen} onOk={this.handleOk} onCancel={this.handleCancel} cancelButtonProps={{ style: { display: 'none' } }}>
                    <div style={{fontFamily: 'Inter', fontSize: 16, lineHeight: '24px', color: '#222'}}><div>Loan purpose is missing.</div> <div>Please provide additional information to proceed.</div></div>
                </Mod>
            </Container>
        );
    }

    getTermOptions = () => {
        const options = [
            { label: '25 year', value: 25 },
            { label: '20 year', value: 20 },
            { label: '15 year', value: 15 },
            { label: '10 year', value: 10 }
        ];
        if (this.state.propertytype !== "manufacturedhome") {
            options.unshift({ label: '30 year', value: 30 });
        }
        return options;
    }
}
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ProductPickerV2)
